/**
 * WeShuddh Side Cart v5 — Everything Works
 */
(function() {
  'use strict';

  var cart = null,
      settings = {},
      productMeta = {},
      milestones = [],
      freebieThresholds = [],
      freebieItems = [],
      conditionalFreebies = [],
      prevFreebieQtyTotal = 0,
      wellnessGoals = [],
      activeGoalId = null,
      peekDone = false,
      peekCloseTimer = null,
      userOpenedWellness = false,
      timerSecs = {},
      timerIDs = {},
      prevMilestone = -1,
      busy = false,
      initialized = false,
      lastFetchAt = 0,
      _wscAddingN = 0;

  /* ─── Helpers ─── */
  function $(id) { return document.getElementById(id); }
  function formatINR(paise) { return '\u20B9' + Math.round(paise / 100).toLocaleString('en-IN'); }
  function escHTML(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function readJSON(id) {
    var el = $(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }
  function emptyCartHTML() {
    return '<div class="wsc-empty">'
      + '<div class="wsc-empty-title">Your cart is empty</div>'
      + '<div class="wsc-empty-sub">Add wellness picks to get started</div>'
      + '<button class="wsc-empty-btn" id="wsc-empty-btn" type="button">Continue Shopping</button>'
      + '</div>';
  }

  /* ─── Settings ─── */
  function loadSettings() {
    settings = readJSON('wsc-settings-data') || {};
    productMeta = readJSON('wsc-product-meta') || {};
    PRODUCT_DATA = settings.product_cards || readJSON('wsc-product-cards') || {};
    FREEBIE_PRODUCT_DATA = settings.freebie_product_cards || {};
    COND_FREEBIE_CARD_DATA = settings.conditional_freebie_cards || {};
    var s = settings;
    // Milestones = freebie tiers (unified system)
    // Falls back to old milestone_N fields if no freebie_tiers
    var tiers = Array.isArray(s.freebie_tiers) ? s.freebie_tiers : [];
    if (tiers.length > 0) {
      milestones = tiers.filter(function(t) { return t.name; }).map(function(t) {
        return { val: t.amount || t.condition_value || 0, label: t.name || '', icon: t.icon || '\uD83C\uDF81', tier: t };
      });
    } else {
      milestones = [
        { val: parseInt(s.milestone_1_amount) || 49900, label: s.milestone_1_label || 'Free Ship', icon: s.milestone_1_icon || '\uD83D\uDE9A' },
        { val: parseInt(s.milestone_2_amount) || 99900, label: s.milestone_2_label || 'Free Gift', icon: s.milestone_2_icon || '\uD83C\uDF81' },
        { val: parseInt(s.milestone_3_amount) || 149900, label: s.milestone_3_label || '10% Off', icon: s.milestone_3_icon || '\uD83D\uDCB0' },
        { val: parseInt(s.milestone_4_amount) || 199900, label: s.milestone_4_label || 'Mystery', icon: s.milestone_4_icon || '\u2728' }
      ];
    }
    // Read dynamic freebie tiers (new format)
    var tiers = Array.isArray(s.freebie_tiers) ? s.freebie_tiers : [];

    // Fallback: migrate from old flat fields if tiers empty
    if (tiers.length === 0) {
      [1, 2, 3].forEach(function(n) {
        var name = s['freebie_' + n + '_product_title'] || s['freebie_' + n + '_name'] || '';
        if (!name) return; // skip empty placeholder slots
        tiers.push({
          amount: parseInt(s['freebie_' + n + '_amount']) || 0,
          name: name,
          icon: s['freebie_' + n + '_icon'] || '\uD83C\uDF81',
          variant_id: s['freebie_' + n + '_variant_id'] || null,
          product_title: s['freebie_' + n + '_product_title'] || '',
          product_image: s['freebie_' + n + '_product_image'] || s['freebie_' + n + '_image'] || '',
          product_handle: s['freebie_' + n + '_product_handle'] || '',
          product_price: parseInt(s['freebie_' + n + '_product_price']) || 0
        });
      });
    }

    freebieThresholds = tiers.map(function(t) { return t.amount; });
    freebieItems = tiers.map(function(t) {
      return {
        name: t.name || t.product_title || '',
        icon: t.icon || '\uD83C\uDF81',
        image: t.product_image || '',
        handle: t.product_handle || '',
        price: t.product_price || 0
      };
    });
    settings.freebie_prepaid_only = s.freebie_prepaid_only !== false;

    // Conditional freebies (rule-based: "if cart has X, show Y as free")
    conditionalFreebies = Array.isArray(s.conditional_freebies) ? s.conditional_freebies : [];

    // Wellness Stack
    wellnessGoals = Array.isArray(s.wellness_goals) ? s.wellness_goals : [];
    activeGoalId = wellnessGoals.length > 0 ? wellnessGoals[0].id : null;
    settings.enable_wellness = s.enable_wellness === true;
    settings.normal_price_size = parseInt(s.normal_price_size) || 15;
    settings.normal_strike_size = parseInt(s.normal_strike_size) || 10;
    settings.cart_name_size = parseInt(s.cart_name_size) || 12;
    settings.cart_subtitle_size = parseInt(s.cart_subtitle_size) || 9;
    settings.cart_star_size = parseInt(s.cart_star_size) || 9;
    settings.cart_pill_size = parseInt(s.cart_pill_size) || 8;
    settings.cart_badge_size = parseInt(s.cart_badge_size) || 7;
    settings.cart_savings_size = parseInt(s.cart_savings_size) || 9;
    settings.wellness_peek_delay = parseInt(s.wellness_peek_delay) || 1500;
    settings.wellness_peek_duration = parseInt(s.wellness_peek_duration) || 4000;
    settings.wellness_wiggle = s.wellness_wiggle !== false;
    settings.wellness_finger = s.wellness_finger !== false;
    settings.wellness_title = s.wellness_title || '\uD83E\uDDEC Wellness Stack';
    settings.enable_also_bought = s.enable_also_bought === true;
    settings.also_bought_title = s.also_bought_title || 'Customers Also Bought';
    settings.also_bought_products = Array.isArray(s.also_bought_products) ? s.also_bought_products : [];

    // Collection-based upsell (safe fallbacks — old metafields lack these keys)
    settings.upsell_title = s.upsell_title || settings.also_bought_title;
    settings.upsell_collection_handle = (typeof s.upsell_collection_handle === 'string') ? s.upsell_collection_handle.trim() : '';
    settings.upsell_max_products = parseInt(s.upsell_max_products) || 6;

    // Brand colors → CSS vars on the drawer root (defaults per shared contract)
    var drawerRoot = $('wsc-drawer');
    if (drawerRoot) {
      drawerRoot.style.setProperty('--wsc-accent', s.wsc_accent || '#052a49');
      drawerRoot.style.setProperty('--wsc-accent-light', s.wsc_accent_light || '#8ecc06');
    }

    // Freebie slots now rendered dynamically by renderFreebieSlots()

    // Hide/show sections based on toggle flags
    hydrateSectionVisibility(s);

    // Hydrate trust badges, golden banner, WhatsApp, prepaid from settings
    hydrateFooterSections(s);

    // Wellness accordion title (dashboard-controlled, keeps SSR text as fallback)
    applyWellnessTitle();

    // Prepaid-only strip under the freebie selector — show ONLY when explicitly true
    var prepaidStrip = $('wsc-prepaid-strip');
    if (prepaidStrip) {
      if (settings.freebie_prepaid_only === true) showEl(prepaidStrip, 'block');
      else hideEl(prepaidStrip);
    }

    // Rotating banner carousel directly under the drawer header
    initBannerCarousel(s);
  }

  function hydrateSectionVisibility(s) {
    // Progress bar
    var progressEl = $('wsc-progress');
    if (progressEl) {
      if (!s.enable_progress_bar) hideEl(progressEl); else showEl(progressEl, 'block');
    }

    // Freebie accordion — header + body are siblings, find via data attribute
    var fbHeader = document.querySelector('[data-wsc-accordion] .wsc-accordion-title');
    if (fbHeader) {
      var fbAccHeader = fbHeader.closest('[data-wsc-accordion]');
      if (fbAccHeader) {
        var fbAccBody = fbAccHeader.nextElementSibling;
        // Only target freebie accordion (has "Free Gifts" in title)
        if (fbAccHeader.textContent.indexOf('Free Gift') !== -1) {
          if (!s.enable_freebie) {
            hideEl(fbAccHeader);
            hideEl(fbAccBody);
            // Also hide the separator before it
            var prevSep = fbAccHeader.previousElementSibling;
            if (prevSep && prevSep.classList.contains('wsc-separator')) hideEl(prevSep);
          }
        }
      }
    }

    // Upsell accordion (matched by badge id — the title text is dashboard-controlled)
    var wellnessHdr = getWellnessHeader();
    var accHeaders = document.querySelectorAll('[data-wsc-accordion]');
    accHeaders.forEach(function(hdr) {
      if (hdr === wellnessHdr || hdr.textContent.indexOf('Wellness') !== -1 || hdr.textContent.indexOf('upsell') !== -1) {
        var body = hdr.nextElementSibling;
        if (!s.enable_upsell && !s.enable_wellness && !s.enable_also_bought) {
          hideEl(hdr);
          hideEl(body);
          var prevSep = hdr.previousElementSibling;
          if (prevSep && prevSep.classList.contains('wsc-separator')) hideEl(prevSep);
        }
      }
    });
  }

  function hideEl(el) { if (el) el.style.setProperty('display', 'none', 'important'); }
  function showEl(el, mode) { if (el) el.style.setProperty('display', mode || 'block', 'important'); }

  // Wellness accordion header — resolved via badge id first (title text is
  // dashboard-controlled and may not contain the word "Wellness" anymore)
  function getWellnessHeader() {
    var badge = $('wsc-wellness-badge');
    if (badge) {
      var hdr = badge.closest('[data-wsc-accordion]');
      if (hdr) return hdr;
    }
    var found = null;
    document.querySelectorAll('[data-wsc-accordion]').forEach(function(h) {
      if (!found && h.textContent.indexOf('Wellness') !== -1) found = h;
    });
    return found;
  }

  function applyWellnessTitle() {
    var hdr = getWellnessHeader();
    if (!hdr) return;
    var titleEl = hdr.querySelector('.wsc-accordion-title');
    if (titleEl && titleEl.firstChild && titleEl.firstChild.nodeType === 3) {
      titleEl.firstChild.nodeValue = (settings.wellness_title || '\uD83E\uDDEC Wellness Stack') + ' ';
    }
  }

  function hydrateFooterSections(s) {
    // Trust badges
    var trustRow = $('wsc-trust-row');
    if (trustRow) {
      if (!s.enable_trust_badges) {
        hideEl(trustRow);
      } else {
        showEl(trustRow, 'flex');
        var badges = [s.trust_1_text, s.trust_2_text, s.trust_3_text, s.trust_4_text, s.trust_5_text].filter(Boolean);
        if (badges.length) {
          trustRow.innerHTML = badges.map(function(b) { return '<span class="wsc-trust-badge">' + escHTML(b) + '</span>'; }).join('');
        }
      }
    }

    // Golden scrolling banner
    var goldenBanner = $('wsc-golden-banner');
    if (goldenBanner) {
      if (!s.enable_golden_banner) {
        hideEl(goldenBanner);
      } else {
        showEl(goldenBanner, 'block');
        var msgs = [s.golden_msg_1, s.golden_msg_2, s.golden_msg_3, s.golden_msg_4].filter(Boolean);
        if (msgs.length) {
          var track = $('wsc-golden-track');
          if (track) {
            var h = '';
            for (var r = 0; r < 2; r++) {
              msgs.forEach(function(m) {
                h += '<span class="wsc-golden-item">' + escHTML(m) + '</span><span class="wsc-golden-sep">\u2726</span>';
              });
            }
            track.innerHTML = h;
          }
        }
      }
    }

    // WhatsApp
    var waRow = $('wsc-wa-row');
    if (waRow) {
      if (!s.enable_whatsapp) {
        hideEl(waRow);
      } else {
        showEl(waRow, 'block');
        var waLink = $('wsc-wa-link');
        if (waLink) {
          var num = s.whatsapp_number || '919315269100';
          var msg = encodeURIComponent(s.whatsapp_message || 'Hi, I need help with my order');
          waLink.href = 'https://wa.me/' + num + '?text=' + msg;
        }
      }
    }

    // Prepaid nudge
    var prepaidEl = $('wsc-ft-prepaid');
    if (prepaidEl) {
      if (!s.enable_prepaid_nudge) {
        hideEl(prepaidEl);
      } else {
        showEl(prepaidEl, 'block');
        var amt = Math.round((parseInt(s.prepaid_discount_paise) || 4000) / 100);
        prepaidEl.textContent = '\uD83D\uDC9A Extra \u20B9' + amt + ' off on prepaid';
      }
    }

    // Coupon strip
    var couponRow = $('wsc-coupon');
    if (couponRow) {
      if (!s.enable_coupon_strip) {
        hideEl(couponRow);
      }
      // Dashboard coupon text — hydrate ONLY over the SSR defaults, never over
      // a real applied discount (updateCoupon() owns that case)
      var couponCodeEl = couponRow.querySelector('.wsc-coupon-code');
      var couponSubEl = couponRow.querySelector('.wsc-coupon-saved');
      if (couponCodeEl && couponCodeEl.textContent.trim() === 'WELCOME15') {
        couponCodeEl.textContent = s.coupon_code || 'WELCOME15';
      }
      if (couponSubEl && couponSubEl.textContent.trim() === 'applies at checkout') {
        couponSubEl.textContent = s.coupon_subtext || 'applies at checkout';
      }
    }

    // Checkout button text
    var ctaBtn = $('wsc-checkout-btn');
    if (ctaBtn && s.checkout_btn_text) ctaBtn.textContent = s.checkout_btn_text;
  }

  /* ─── Banner Carousel (under the drawer header) ─── */
  var _wscBannerTimer = null;
  function initBannerCarousel(s) {
    var strip = $('wsc-banner-strip');
    if (!strip) return;
    if (_wscBannerTimer) { clearInterval(_wscBannerTimer); _wscBannerTimer = null; }

    var slides = [];
    [1, 2, 3].forEach(function(n) {
      var txt = s['banner_' + n + '_text'];
      if (txt && String(txt).trim() !== '') {
        var bg = String(s['banner_' + n + '_bg'] || '#052a49').replace(/["';]/g, '');
        slides.push({ text: String(txt), bg: bg || '#052a49' });
      }
    });

    if (s.enable_banners === false || slides.length === 0) {
      strip.innerHTML = '';
      hideEl(strip);
      return;
    }

    var html = '';
    slides.forEach(function(sl, i) {
      html += '<div class="wsc-banner-slide' + (i === 0 ? ' wsc-banner-active' : '')
        + '" style="background:' + escHTML(sl.bg) + ' !important">' + escHTML(sl.text) + '</div>';
    });
    strip.innerHTML = html;
    showEl(strip, 'block');

    // Fade-rotate every 3.5s — single interval, skipped when only one slide
    if (slides.length > 1) {
      var idx = 0;
      _wscBannerTimer = setInterval(function() {
        var els = strip.querySelectorAll('.wsc-banner-slide');
        if (!els.length) return;
        els[idx % els.length].classList.remove('wsc-banner-active');
        idx = (idx + 1) % els.length;
        els[idx].classList.add('wsc-banner-active');
      }, 3500);
    }
  }

  /* ═══════════════════════════════════════
     CART API
     ═══════════════════════════════════════ */

  function fetchCart(cb) {
    // throttle: any caller within 1.5s reuses the cached cart (kills poll storms)
    if (cart && Date.now() - lastFetchAt < 1500) { if (cb) cb(cart); return; }
    lastFetchAt = Date.now();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) { console.error('WSC: /cart.js responded', r.status); return null; }
        return r.json();
      })
      .then(function(c) { if (c) { cart = c; if (cb) cb(c); } })
      .catch(function(e) { console.error('WSC:', e); });
  }

  function changeQty(key, qty) {
    if (busy) return;
    busy = true;

    var itemEl = document.querySelector('.wsc-item[data-key="' + key + '"]');
    if (qty === 0 && itemEl) {
      itemEl.style.transition = 'opacity .15s, max-height .25s ease';
      itemEl.style.opacity = '0';
      setTimeout(function() {
        if (itemEl) { itemEl.style.maxHeight = '0'; itemEl.style.overflow = 'hidden'; itemEl.style.margin = '0'; itemEl.style.padding = '0'; }
      }, 100);
    } else if (itemEl) {
      itemEl.style.opacity = '.5';
      var qn = itemEl.querySelector('.wsc-item-qty-num');
      if (qn) qn.textContent = qty;
    }

    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('/cart/change.js responded ' + r.status);
      return r.json();
    })
    .then(function(c) {
      cart = c; busy = false;
      // Surgical DOM update — don't re-render items, just fix the changed one
      var itemEl = document.querySelector('.wsc-item[data-key="' + key + '"]');
      if (itemEl) {
        if (qty === 0) {
          itemEl.remove();
        } else {
          itemEl.style.opacity = '';
          itemEl.style.transition = '';
        }
      }
      if (cart.items.length === 0) {
        var el = $('wsc-items');
        if (el) el.innerHTML = emptyCartHTML();
      }
      fetchMissingMeta();
      populateCartItems();
      updateProgress();
      updateFreebies();
      renderInlineTeaser();
      renderWellnessTimeline(activeGoalId);
      renderAlsoBought();
      renderVolumeTier();
      renderBundleNudge();
      updateFooter();
    })
    .catch(function(e) {
      busy = false; console.error('WSC:', e);
      var itemEl2 = document.querySelector('.wsc-item[data-key="' + key + '"]');
      if (itemEl2) { itemEl2.style.opacity = ''; itemEl2.style.transition = ''; }
      updateFooter();
    });
  }

  function addToCart(variantId, qty, cb) {
    if (busy) return;
    busy = true;
    _wscAddingN++;

    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: qty || 1 }] })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('/cart/add.js responded ' + r.status);
      return r.json();
    })
    .then(function(addResp) {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) {
        if (!r.ok) throw new Error('/cart.js responded ' + r.status);
        return r.json();
      });
    })
    .then(function(c) {
      cart = c; busy = false; _wscAddingN = Math.max(0,_wscAddingN-1); lastFetchAt = Date.now();
      refreshUI();
      openDrawer(true);
      if (cb) cb(c);
    })
    .catch(function(e) {
      busy = false; _wscAddingN = Math.max(0,_wscAddingN-1); console.error('WSC:', e);
      // Restore any upsell/bundle buttons stuck in loading state
      document.querySelectorAll('.wsc-tl-card-add[disabled], .wsc-sp-card-add[disabled], .wsc-bn-add[disabled]').forEach(function(btn) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-orig-text') || '+ Add';
      });
    });
  }

  // Per-product card data — loaded from theme editor blocks (wsc-settings section)
  var PRODUCT_DATA = {};
  var FREEBIE_PRODUCT_DATA = {};
  var COND_FREEBIE_CARD_DATA = {};

  function buildPillHTML(text, bg, color, border, pulse, wiggle) {
    var cls = 'wsc-item-tag' + (pulse ? ' wsc-tag-pulse' : '') + (wiggle ? ' wsc-tag-wiggle' : '');
    var style = 'font-size:' + (settings.cart_pill_size || 8) + 'px !important;';
    if (bg) style += 'background:' + bg + ' !important;';
    if (color) style += 'color:' + color + ' !important;';
    if (border && border !== 'none') {
      style += 'border:1px ' + border + ' ' + (color || '#052a49') + ' !important;';
    }
    return '<span class="' + cls + '"' + (style ? ' style="' + style + '"' : '') + '>' + escHTML(text) + '</span>';
  }

  function populateCartItems() {
    if (!cart || !cart.items) return;
    cart.items.forEach(function(ci) {
      var el = document.querySelector('.wsc-item[data-key="' + ci.key + '"]');
      if (!el) return;
      var d = PRODUCT_DATA[ci.handle] || {};

      // Title override
      if (d.title) {
        var nameEl = el.querySelector('.wsc-item-name');
        if (nameEl) nameEl.textContent = d.title;
      }

      // Subtitle below product name
      if (d.sub) {
        var nameEl2 = el.querySelector('.wsc-item-name');
        if (nameEl2 && !el.querySelector('.wsc-item-sub')) {
          var subEl = document.createElement('div');
          subEl.className = 'wsc-item-sub';
          subEl.textContent = d.sub;
          nameEl2.insertAdjacentElement('afterend', subEl);
        }
      }

      // Pills — exactly 2 max, both in .wsc-item-tags row, custom colors + borders
      var tagsEl = el.querySelector('.wsc-item-tags');
      if (tagsEl) {
        if (settings.enable_pills && (d.p1 || d.p2)) {
          var h = '';
          if (d.p1) h += buildPillHTML(d.p1, d.p1bg, d.p1c, d.p1b, d.p1p, d.p1w);
          if (d.p2) h += buildPillHTML(d.p2, d.p2bg, d.p2c, d.p2b, d.p2p, d.p2w);
          tagsEl.innerHTML = h;
          showEl(tagsEl, 'flex');
        } else {
          hideEl(tagsEl);
        }
      }

      // Stars — hide engage row when no rating data or stars disabled
      var engageEl = el.querySelector('.wsc-item-engage');
      if (engageEl) {
        if (settings.enable_star_ratings && d.rating) {
          showEl(engageEl, 'flex');
          engageEl.innerHTML = '<span class="wsc-item-stars" style="font-size:' + settings.cart_star_size + 'px !important">\u2605\u2605\u2605\u2605\u2605</span>'
            + '<span class="wsc-item-rating">' + escHTML(d.rating) + (d.sold ? ' \u00B7 ' + escHTML(d.sold) + ' sold' : '') + '</span>';
        } else {
          hideEl(engageEl);
        }
      }
    });
  }

  /* ═══════════════════════════════════════
     IMAGE URL FIX
     ═══════════════════════════════════════ */

  function getImgUrl(item) {
    if (!item.image) return '';
    var url = item.image;
    // Shopify CDN: add width param if not present
    if (url.indexOf('cdn.shopify.com') !== -1) {
      if (url.indexOf('width=') === -1) {
        url += (url.indexOf('?') !== -1 ? '&' : '?') + 'width=200';
      }
      return url;
    }
    // Legacy format fallback
    return url;
  }

  /* ═══════════════════════════════════════
     RENDER CART ITEMS (scroll-safe)
     ═══════════════════════════════════════ */

  function renderItems() {
    var el = $('wsc-items');
    if (!el || !cart) return;

    // Save scroll position
    var body = $('wsc-body');
    var scrollTop = body ? body.scrollTop : 0;

    if (cart.items.length === 0) {
      el.innerHTML = emptyCartHTML();
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var meta = productMeta[item.variant_id] || {};
      var d = PRODUCT_DATA[item.handle] || {};
      var compareAt = meta.compare_at_price || item.original_price;
      var savings = compareAt - item.price;
      var pctOff = compareAt > item.price ? Math.round((savings / compareAt) * 100) : 0;
      var imgUrl = getImgUrl(item);

      // Stars from PRODUCT_DATA (not productMeta)
      var starsHtml = '';
      if (settings.enable_star_ratings && d.rating) {
        starsHtml = '<div class="wsc-item-engage" style="display:flex !important"><span class="wsc-item-stars">\u2605\u2605\u2605\u2605\u2605</span>'
          + '<span class="wsc-item-rating">' + escHTML(d.rating)
          + (d.sold ? ' \u00B7 ' + escHTML(d.sold) + ' sold' : '') + '</span></div>';
      }

      html += '<div class="wsc-item" data-key="' + item.key + '" data-variant="' + item.variant_id + '" data-handle="' + escHTML(item.handle) + '">'
        + '<div class="wsc-item-img">'
        + (imgUrl ? '<img src="' + imgUrl + '" alt="' + escHTML(item.product_title) + '" loading="lazy">' : '')
        + (pctOff > 0 && settings.show_discount_badge !== false ? '<div class="wsc-item-disc" style="font-size:' + settings.cart_badge_size + 'px !important">' + pctOff + '% OFF</div>' : '')
        + '</div>'
        + '<div class="wsc-item-body">'
        + '<div class="wsc-item-name" style="font-size:' + settings.cart_name_size + 'px !important">' + escHTML(d.title || item.product_title) + '</div>'
        + (function(){
            // Variant name wins over the generic card subtitle — otherwise two variants of the
            // same product (e.g. Kridavati 1-Month vs 2-Month) render identically. 2026-08-12
            var vt = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
            var subText = vt || d.sub;
            return subText ? '<div class="wsc-item-sub" style="font-size:' + settings.cart_subtitle_size + 'px !important">' + escHTML(subText) + '</div>' : '';
          })()
        + '<div class="wsc-item-tags" style="display:none !important"></div>'
        + starsHtml
        + '</div>'
        + '<div class="wsc-item-right">'
        + '<div class="wsc-item-price-block">'
        + '<div class="wsc-item-final" style="font-size:' + (settings.normal_price_size || 15) + 'px !important">' + formatINR(item.price) + '</div>'
        + (compareAt > item.price
          ? '<div class="wsc-item-orig" style="font-size:' + (settings.normal_strike_size || 10) + 'px !important">' + formatINR(compareAt) + '</div>'
            + (settings.show_savings_per_item !== false ? '<div class="wsc-item-save" style="font-size:' + settings.cart_savings_size + 'px !important">Save ' + formatINR(savings) + '</div>' : '')
          : '')
        + '</div>'
        + '<div class="wsc-item-qty">'
        + '<button class="wsc-item-qty-btn wsc-qty-minus" type="button" data-key="' + item.key + '">\u2212</button>'
        + '<span class="wsc-item-qty-num">' + item.quantity + '</span>'
        + '<button class="wsc-item-qty-btn wsc-qty-plus" type="button" data-key="' + item.key + '">+</button>'
        + '</div>'
        + '</div></div>';
    });

    el.innerHTML = html;

    // Restore scroll position
    if (body) body.scrollTop = scrollTop;
  }

  /* ═══════════════════════════════════════
     EVENT DELEGATION
     ═══════════════════════════════════════ */

  function initEventDelegation() {
    var drawer = $('wsc-drawer');
    if (!drawer) return;

    drawer.addEventListener('click', function(e) {
      var target = e.target;

      // Individual freebie claim button
      var claimBtn = target.closest('[data-claim-slot]');
      if (claimBtn) {
        e.stopPropagation();
        var slotIdx = parseInt(claimBtn.getAttribute('data-claim-slot'));
        if (!isNaN(slotIdx)) claimSlot(slotIdx);
        return;
      }

      // Volume tier option — set the real quantity via changeQty
      var vtBtn = target.closest('.wsc-vt-opt');
      if (vtBtn) {
        e.stopPropagation();
        if (busy) return;
        var vtKey = vtBtn.getAttribute('data-vt-key');
        var vtQty = parseInt(vtBtn.getAttribute('data-vt-qty'));
        if (vtKey && vtQty > 0 && !vtBtn.classList.contains('wsc-vt-active')) changeQty(vtKey, vtQty);
        return;
      }

      // Bundle nudge — add the missing combo item via addToCart
      var bnBtn = target.closest('.wsc-bn-add');
      if (bnBtn) {
        e.stopPropagation();
        if (busy) return;
        var bnVid = bnBtn.getAttribute('data-bn-variant');
        if (bnVid) {
          bnBtn.setAttribute('data-orig-text', bnBtn.textContent);
          bnBtn.textContent = '...';
          bnBtn.disabled = true;
          addToCart(bnVid, 1);
        }
        return;
      }

      // Inline teaser click — scroll to wellness and open it
      var teaser = target.closest('#wsc-inline-teaser');
      if (teaser) {
        openWellnessAccordion();
        return;
      }

      // Goal pill click
      var goalPill = target.closest('.wsc-goal-pill');
      if (goalPill) {
        var gid = goalPill.getAttribute('data-goal-id');
        if (gid) renderWellnessTimeline(gid);
        return;
      }

      // Breakdown toggle — any click on footer total area
      if (!target.closest('#wsc-checkout-btn') && (target.closest('.wsc-ft-main') || target.closest('#wsc-ft-breakdown-btn'))) {
        e.stopPropagation();
        toggleBreakdown();
        return;
      }

      // Product card click — open product page
      var productCard = target.closest('[data-handle]');
      if (productCard && !target.closest('button, .wsc-item-qty, .wsc-item-qty-btn, .wsc-qty-minus, .wsc-qty-plus')) {
        var handle = productCard.getAttribute('data-handle');
        if (handle) {
          window.location.href = '/products/' + handle;
          return;
        }
      }

      var btn = target.closest('button, [data-wsc-accordion]');
      if (!btn) return;

      // Qty minus
      if (btn.classList.contains('wsc-qty-minus')) {
        e.stopPropagation();
        var key = btn.getAttribute('data-key');
        var item = cart && cart.items.find(function(i) { return i.key === key; });
        if (item) changeQty(key, Math.max(0, item.quantity - 1));
        return;
      }

      // Qty plus
      if (btn.classList.contains('wsc-qty-plus')) {
        e.stopPropagation();
        var key2 = btn.getAttribute('data-key');
        var item2 = cart && cart.items.find(function(i) { return i.key === key2; });
        if (item2) changeQty(key2, item2.quantity + 1);
        return;
      }

      // Upsell add buttons
      if (btn.classList.contains('wsc-tl-card-add') || btn.classList.contains('wsc-sp-card-add')) {
        e.stopPropagation();
        var vid = btn.getAttribute('data-variant');
        if (!vid || vid.indexOf('VARIANT_ID') !== -1) {
          console.warn('WSC: No variant ID on upsell button');
          return;
        }
        var origText = btn.textContent;
        btn.setAttribute('data-orig-text', origText);
        btn.textContent = '...';
        btn.disabled = true;
        addToCart(vid, 1, function() {
          btn.textContent = '\u2713 Added';
          setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
        });
        return;
      }



      // Close
      if (btn.id === 'wsc-close') { closeDrawer(); return; }

      // Empty-state "Continue Shopping"
      if (btn.id === 'wsc-empty-btn') { closeDrawer(); return; }

      // Checkout
      if (btn.id === 'wsc-checkout-btn') { goToCheckout(); return; }



      // Accordion
      var accordion = btn.closest('[data-wsc-accordion]');
      // Stop wiggle when freebie accordion is opened
      if (accordion && accordion.classList.contains('wsc-accordion-wiggle')) {
        accordion.classList.remove('wsc-accordion-wiggle');
      }
      if (accordion) {
        var body = accordion.nextElementSibling;
        if (!body) return;
        var arrow = accordion.querySelector('.wsc-accordion-arrow');
        if (body.classList.contains('wsc-accordion-expanded')) {
          body.classList.remove('wsc-accordion-expanded');
          if (arrow) arrow.classList.remove('wsc-arrow-open');
        } else {
          body.classList.add('wsc-accordion-expanded');
          if (arrow) arrow.classList.add('wsc-arrow-open');
        }
        return;
      }


    });
  }

  /* ═══════════════════════════════════════
     FREEBIE CLAIM — DOM placeholder cards (no real line items);
     claims are synced to a cart attribute for fulfilment
     ═══════════════════════════════════════ */

  // Per-slot claim state (sessionStorage)
  function isSlotClaimed(index) {
    try { return sessionStorage.getItem('wsc_fb_' + index) === '1'; } catch(e) { return false; }
  }
  function setSlotClaimed(index) {
    try { sessionStorage.setItem('wsc_fb_' + index, '1'); } catch(e) {}
  }
  function clearSlotClaimed(index) {
    try { sessionStorage.removeItem('wsc_fb_' + index); } catch(e) {}
  }

  // Names of freebies that are both claimed and currently unlocked (sequential rules)
  function getClaimedFreebieNames() {
    if (!cart) return [];
    var names = [];
    var prevOk = true;
    freebieItems.forEach(function(fb, i) {
      var tier = (settings.freebie_tiers || [])[i] || {};
      if (tier.reward_type === 'label') {
        prevOk = isTierUnlocked(tier, cart) && prevOk;
        return;
      }
      if (!fb.name || !fb.handle) return;
      var met = isTierUnlocked(tier, cart) && prevOk;
      prevOk = met;
      if (met && isSlotClaimed(i)) names.push(fb.name);
    });
    return names;
  }

  // Sync claimed freebies onto the cart as an attribute so the order carries
  // the claim for fulfilment. Debounced 500ms, fire-and-forget; never
  // re-renders from its response.
  var _wscFbAttrTimer = null;
  function syncFreebieAttributes() {
    if (_wscFbAttrTimer) clearTimeout(_wscFbAttrTimer);
    _wscFbAttrTimer = setTimeout(function() {
      _wscFbAttrTimer = null;
      var val = getClaimedFreebieNames().join(', ');
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'WSC Free Gifts': val } })
      }).catch(console.error);
    }, 500);
  }

  function claimSlot(index) {
    if (!cart) return;
    setSlotClaimed(index);
    syncFreebieAttributes();
    updateFreebies();
    updateFooter();
    // Confetti AFTER render so the card exists in DOM
    if (settings.enable_confetti !== false) {
      setTimeout(function() {
        var card = document.querySelector('.wsc-freebie-item[data-freebie="' + index + '"][data-freebie-type="threshold"]');
        triggerConfetti(card);
      }, 50);
    }
  }

  // Dynamic slot bar rendering


  function isTierProgress(tier, cart) {
    if (!cart) return 0;
    var total = cart.total_price;
    var totalQty = cart.item_count;
    var uniqueProducts = [];
    cart.items.forEach(function(item) {
      if (uniqueProducts.indexOf(item.handle) === -1) uniqueProducts.push(item.handle);
    });
    var uniqueCount = uniqueProducts.length;
    var type = tier.condition_type || 'cart_value';
    var val = tier.condition_value || tier.amount || 0;
    var val2 = tier.condition_value2 || 0;

    if (val === 0) return 0;
    switch (type) {
      case 'cart_value': return Math.min(100, Math.round((total / val) * 100));
      case 'total_qty': return Math.min(100, Math.round((totalQty / val) * 100));
      case 'unique_products': return Math.min(100, Math.round((uniqueCount / val) * 100));
      case 'value_and_qty':
        var p1 = val > 0 ? Math.min(100, (total / val) * 100) : 100;
        var p2 = val2 > 0 ? Math.min(100, (totalQty / val2) * 100) : 100;
        return Math.round((p1 + p2) / 2);
      case 'value_and_unique':
        var p3 = val > 0 ? Math.min(100, (total / val) * 100) : 100;
        var p4 = val2 > 0 ? Math.min(100, (uniqueCount / val2) * 100) : 100;
        return Math.round((p3 + p4) / 2);
      default: return val > 0 ? Math.min(100, Math.round((total / val) * 100)) : 0;
    }
  }

  function isTierUnlocked(tier, cart) {
    if (!cart) return false;
    var total = cart.total_price;
    var totalQty = cart.item_count;
    var uniqueProducts = [];
    cart.items.forEach(function(item) {
      if (uniqueProducts.indexOf(item.handle) === -1) uniqueProducts.push(item.handle);
    });
    var uniqueCount = uniqueProducts.length;
    var type = tier.condition_type || 'cart_value';
    var val = tier.condition_value || tier.amount || 0;
    var val2 = tier.condition_value2 || 0;

    switch (type) {
      case 'cart_value': return total >= val;
      case 'total_qty': return totalQty >= val;
      case 'unique_products': return uniqueCount >= val;
      case 'value_and_qty': return total >= val && totalQty >= val2;
      case 'value_and_unique': return total >= val && uniqueCount >= val2;
      default: return total >= val;
    }
  }

  function renderFreebieSlots() {
    var bar = document.getElementById('wsc-fb-bar');
    if (!bar) return;
    bar.innerHTML = '';
    var total = cart ? cart.total_price : 0;

    var prevTierUnlocked = true;
    freebieItems.forEach(function(fb, i) {
      var tier = (settings.freebie_tiers || [])[i] || {};
      // Label-only milestones don't show in freebie section
      if (tier.reward_type === 'label') {
        // Still track sequential unlock state
        var met = isTierUnlocked(tier, cart);
        prevTierUnlocked = met && prevTierUnlocked;
        return;
      }
      if (!fb.name || !fb.handle) { return; }
      var threshold = freebieThresholds[i];
      var tier = (settings.freebie_tiers || [])[i] || {};
      var conditionMet = isTierUnlocked(tier, cart);
      var isUnlocked = conditionMet && prevTierUnlocked;
      var isClaimed = isSlotClaimed(i) && isUnlocked;
      if (!isUnlocked) clearSlotClaimed(i);

      var condType = tier.condition_type || 'cart_value';
      var condVal = tier.condition_value || tier.amount || 0;
      var condVal2 = tier.condition_value2 || 0;
      var totalQty = cart ? cart.item_count : 0;
      var uniqueHandles = [];
      if (cart) cart.items.forEach(function(item) { if (uniqueHandles.indexOf(item.handle) === -1) uniqueHandles.push(item.handle); });
      var uniqueCount = uniqueHandles.length;
      var remaining = 0;
      var pct = 0;

      var imgHtml = '';
      if (fb.image) {
        imgHtml = '<img src="' + escHTML(fb.image) + (fb.image.indexOf('?') !== -1 ? '&width=80' : '?width=80') + '" style="width:100%;height:100%;object-fit:cover;border-radius:5px">';
      } else {
        imgHtml = '<span style="font-size:18px">' + (fb.icon || '\uD83C\uDF81') + '</span>';
      }

      var rightHtml = '';
      if (isClaimed) {
        rightHtml = '<div style="font-size:8px;color:#2b7a3f;font-weight:700;flex-shrink:0;margin-left:4px;max-width:90px;text-align:right">Claimed \u2014 added to your order notes</div>';
      } else if (isUnlocked) {
        rightHtml = '<div style="flex-shrink:0;margin-left:4px"><button data-claim-slot="' + i + '" style="font-size:9px;padding:5px 12px;background:var(--wsc-accent, #2b7a3f);color:#fff;border:none;border-radius:5px;font-weight:700;cursor:pointer;white-space:nowrap">Claim</button></div>';
      } else {
        rightHtml = '<div style="font-size:8px;color:#999;font-weight:600;flex-shrink:0;margin-left:4px">\uD83D\uDD12</div>';
      }

      var statusText = '';
      var barColor = '#2b7a3f';
      if (isClaimed) {
        statusText = '\u2713 Claimed! Worth ' + formatINR(fb.price);
        barColor = '#2b7a3f';
      } else if (isUnlocked) {
        statusText = '\u2713 Unlocked! Worth ' + formatINR(fb.price);
        barColor = '#2b7a3f';
      } else {
        if (condType === 'cart_value' || condType === 'value_and_qty' || condType === 'value_and_unique') {
          remaining = Math.ceil((condVal - total) / 100);
          pct = Math.min(100, Math.round((total / condVal) * 100));
          statusText = 'Add <strong style="color:#2b7a3f">\u20B9' + remaining + '</strong> more';
        }
        if (condType === 'total_qty') {
          remaining = condVal - totalQty;
          pct = Math.min(100, Math.round((totalQty / condVal) * 100));
          statusText = 'Add <strong style="color:#2b7a3f">' + remaining + ' more item' + (remaining > 1 ? 's' : '') + '</strong>';
        }
        if (condType === 'unique_products') {
          remaining = condVal - uniqueCount;
          pct = Math.min(100, Math.round((uniqueCount / condVal) * 100));
          statusText = 'Add <strong style="color:#2b7a3f">' + remaining + ' more product' + (remaining > 1 ? 's' : '') + '</strong>';
        }
        if (condType === 'value_and_qty') {
          var vMet = total >= condVal;
          var qMet = totalQty >= condVal2;
          if (!vMet && !qMet) statusText = 'Add <strong style="color:#2b7a3f">' + (condVal2 - totalQty) + ' more item' + ((condVal2-totalQty)>1?'s':'') + '</strong> (min <strong style="color:#2b7a3f">\u20B9' + Math.ceil((condVal-total)/100) + '</strong>)';
          else if (!vMet) statusText = 'Add <strong style="color:#2b7a3f">\u20B9' + Math.ceil((condVal-total)/100) + '</strong> more';
          else statusText = 'Add <strong style="color:#2b7a3f">' + (condVal2-totalQty) + ' more item' + ((condVal2-totalQty)>1?'s':'') + '</strong>';
          pct = Math.min(100, Math.round(((vMet ? 50 : (total/condVal)*50) + (qMet ? 50 : (totalQty/condVal2)*50))));
        }
        if (condType === 'value_and_unique') {
          var vMet2 = total >= condVal;
          var uMet = uniqueCount >= condVal2;
          if (!vMet2 && !uMet) statusText = 'Add <strong style="color:#2b7a3f">' + (condVal2-uniqueCount) + ' more product' + ((condVal2-uniqueCount)>1?'s':'') + '</strong> (min <strong style="color:#2b7a3f">\u20B9' + Math.ceil((condVal-total)/100) + '</strong>)';
          else if (!vMet2) statusText = 'Add <strong style="color:#2b7a3f">\u20B9' + Math.ceil((condVal-total)/100) + '</strong> more';
          else statusText = 'Add <strong style="color:#2b7a3f">' + (condVal2-uniqueCount) + ' more product' + ((condVal2-uniqueCount)>1?'s':'') + '</strong>';
          pct = Math.min(100, Math.round(((vMet2 ? 50 : (total/condVal)*50) + (uMet ? 50 : (uniqueCount/condVal2)*50))));
        }
        if (conditionMet && !isUnlocked) {
          statusText = 'Unlock previous first';
          barColor = '#a3164e';
        }
        if (!statusText) statusText = 'Keep adding!';
        barColor = barColor || '#f5a623';
      }

      var borderStyle = isClaimed ? 'border:1.5px solid #2b7a3f;background:#eef7e0' : (isUnlocked ? 'border:1.5px solid #2b7a3f;background:#eef7e0' : 'border:1px solid #e8e0d2;background:#fff');
      var opacityStyle = (!isUnlocked && !isClaimed) ? ';opacity:.6' : '';

      var html = '<div style="' + borderStyle + ';border-radius:8px;padding:8px;margin-bottom:6px' + opacityStyle + '">'
        + '<div style="display:flex;gap:8px;align-items:center">'
        + '<div style="width:36px;height:36px;border-radius:6px;background:#eef7e0;display:flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden">' + imgHtml + '</div>'
        + '<div style="flex:1;min-width:0">'
        + '<div style="font-size:10px;font-weight:600;color:#052a49;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + escHTML(fb.name) + '</div>'
        + '<div style="font-size:9px;color:' + (isUnlocked || isClaimed ? '#2b7a3f' : '#999') + ';font-weight:600">' + statusText + '</div>'
        + '<div style="height:3px;background:#eee;border-radius:2px;margin-top:3px"><div style="width:' + pct + '%;height:100%;background:' + barColor + ';border-radius:2px;transition:width .3s"></div></div>'
        + '</div>'
        + rightHtml
        + '</div></div>';

      bar.insertAdjacentHTML('beforeend', html);
      prevTierUnlocked = isUnlocked;
    });
  }


  function buildFreebieCardHTML(fb, index, type) {
    // Image — use product image, fallback to emoji icon
    var imgHtml = '';
    if (fb.image) {
      var imgUrl = fb.image;
      if (imgUrl.indexOf('cdn.shopify.com') !== -1 && imgUrl.indexOf('width=') === -1) {
        imgUrl += (imgUrl.indexOf('?') !== -1 ? '&' : '?') + 'width=200';
      }
      imgHtml = '<img src="' + escHTML(imgUrl) + '" alt="' + escHTML(fb.name) + '" loading="lazy">';
    } else if (fb.icon) {
      imgHtml = '<span style="font-size:28px;display:flex;align-items:center;justify-content:center;width:100%;height:100%">' + fb.icon + '</span>';
    }

    // Look up freebie-specific card data first, then fall back to normal product data
    var handle = fb.free_handle || fb.handle || fb.condition_handle || '';
    var d = handle ? (type === 'conditional' ? (COND_FREEBIE_CARD_DATA[handle] || FREEBIE_PRODUCT_DATA[handle] || PRODUCT_DATA[handle] || {}) : (FREEBIE_PRODUCT_DATA[handle] || PRODUCT_DATA[handle] || {})) : {};

    // Pills
    var pillsHtml = '';
    if (settings.enable_pills && (d.p1 || d.p2)) {
      pillsHtml = '<div class="wsc-item-tags" style="display:flex !important">';
      if (d.p1) pillsHtml += buildPillHTML(d.p1, d.p1bg, d.p1c, d.p1b, d.p1p, d.p1w);
      if (d.p2) pillsHtml += buildPillHTML(d.p2, d.p2bg, d.p2c, d.p2b, d.p2p, d.p2w);
      pillsHtml += '</div>';
    }

    // Stars
    var starsHtml = '';
    if (settings.enable_star_ratings && d.rating) {
      starsHtml = '<div class="wsc-item-engage" style="display:flex !important">'
        + '<span class="wsc-item-stars" style="font-size:' + settings.cart_star_size + 'px !important">\u2605\u2605\u2605\u2605\u2605</span>'
        + '<span class="wsc-item-rating">' + escHTML(d.rating) + (d.sold ? ' \u00B7 ' + escHTML(d.sold) + ' sold' : '') + '</span></div>';
    }

    // Sub line
    var subHtml = d.sub
      ? '<div class="wsc-item-sub" style="font-size:' + settings.cart_subtitle_size + 'px !important">' + escHTML(d.sub) + '</div>'
      : '<div class="wsc-item-sub" style="color:#2b7a3f !important;font-size:10px !important;font-weight:600 !important">\uD83C\uDF81 Free Gift</div>';

    // Quantity display (for freebies with qty > 1)
    var qtyVal = parseInt(fb.free_qty) || 1;
    var qtyHtml = '<div style="font-size:12px !important;color:#666 !important;font-weight:700 !important;margin-top:8px !important;text-align:right !important">Qty ' + qtyVal + '</div>';

    // Price block: FREE (bigger) + strikethrough original
    var priceHtml = '<div class="wsc-item-final" style="color:#2b7a3f !important;font-weight:700 !important;font-size:' + (settings.freebie_free_size || 17) + 'px !important">FREE</div>';
    if (fb.price && fb.price > 0) {
      priceHtml += '<div class="wsc-item-worth" style="font-size:' + (settings.freebie_worth_size || 12) + 'px !important">Worth ' + formatINR(fb.price) + '</div>';
    }

    // Effect data attributes (controlled from dashboard)
    var fxAttrs = '';
    if (settings.freebie_fx_glow !== false) fxAttrs += ' data-fx-glow="1"';
    if (settings.freebie_fx_gradient !== false) fxAttrs += ' data-fx-gradient="1"';
    if (settings.freebie_fx_pulse_border !== false) fxAttrs += ' data-fx-pulse="1"';
    var bubbleHtml = (settings.freebie_fx_gift_bubble !== false)
      ? '<div class="wsc-freebie-gift-bubble">\uD83C\uDF81</div>' : '';

    return '<div class="wsc-item wsc-freebie-item" data-freebie="' + index + '" data-freebie-type="' + type + '"'
      + (handle ? ' data-handle="' + escHTML(handle) + '"' : '') + fxAttrs + '>'
      + bubbleHtml
      + '<div class="wsc-item-img">' + imgHtml
      + (settings.freebie_show_free_badge !== false ? '<div class="wsc-item-disc" style="background:#2b7a3f !important;color:#fff !important;font-weight:700 !important">FREE</div>' : '')
      + '</div>'
      + '<div class="wsc-item-body">'
      + '<div class="wsc-item-name" style="font-size:' + settings.cart_name_size + 'px !important">' + escHTML(fb.name) + '</div>'
      + subHtml
      + pillsHtml
      + starsHtml
      + '</div>'
      + '<div class="wsc-item-right" style="justify-content:center !important">'
      + '<div class="wsc-item-price-block">' + priceHtml + '</div>'
      + qtyHtml
      + '</div></div>';
  }

  function getMatchedConditionalFreebies() {
    if (!cart || !conditionalFreebies.length) return [];
    var matched = [];
    conditionalFreebies.forEach(function(rule) {
      if (!rule.condition_handle) return;
      // For BXGX, name defaults to condition_product_title
      var ruleName = rule.name || rule.condition_product_title || '';
      if (!ruleName) return;
      var minQty = parseInt(rule.condition_qty) || 1;
      var found = cart.items.find(function(item) {
        return item.handle === rule.condition_handle && item.quantity >= minQty;
      });
      if (found) {
        // Ensure the rule has usable fields for rendering
        // Dynamic qty: free = floor(cart_qty / buy_qty) * free_per_trigger
        var buyQty = parseInt(rule.condition_qty) || 1;
        var freePerTrigger = parseInt(rule.free_qty) || 1;
        var maxFree = parseInt(rule.max_free) || 0;
        var cartItemQty = found.quantity;
        var dynamicFreeQty = Math.floor(cartItemQty / buyQty) * freePerTrigger;
        if (maxFree > 0) dynamicFreeQty = Math.min(dynamicFreeQty, maxFree);

        var enriched = {
          name: ruleName,
          icon: rule.icon || '\uD83C\uDF81',
          image: rule.image || '',
          price: rule.price || 0,
          free_handle: rule.free_handle || rule.condition_handle,
          free_qty: dynamicFreeQty,
          condition_handle: rule.condition_handle,
          rule_type: rule.rule_type || 'bxgy'
        };
        // For BXGX, try to get image from the cart item if not set
        if (enriched.rule_type === 'bxgx' && !enriched.image && found.image) {
          enriched.image = found.image;
        }
        matched.push(enriched);
      }
    });
    return matched;
  }

  function renderFreebieCartItems() {
    var el = $('wsc-items');
    if (!el || !cart) return;

    // Remove existing freebie placeholders
    el.querySelectorAll('.wsc-freebie-item').forEach(function(f) { f.remove(); });

    var total = cart.total_price;

    // 1. Threshold-based freebies — sequential unlock
    var prevTierOk = true;
    for (var i = 0; i < freebieItems.length; i++) {
      var tierRC = (settings.freebie_tiers || [])[i] || {};
      if (tierRC.reward_type === 'label') {
        var metRC = isTierUnlocked(tierRC, cart);
        prevTierOk = metRC && prevTierOk;
        continue;
      }
      if (!freebieItems[i].name || !freebieItems[i].handle) continue;
      var tier = (settings.freebie_tiers || [])[i] || {};
      var tierMet = isTierUnlocked(tier, cart) && prevTierOk;
      prevTierOk = tierMet;
      if (!tierMet) {
        clearSlotClaimed(i);
        continue;
      }
      if (!isSlotClaimed(i)) continue;
      el.insertAdjacentHTML('beforeend', buildFreebieCardHTML(freebieItems[i], i, 'threshold'));
    }

    // 2. Conditional freebies (auto-show when conditions met, no claim needed)
    var matchedRules = getMatchedConditionalFreebies();
    var newFreebieQtyTotal = 0;
    matchedRules.forEach(function(rule, idx) {
      el.insertAdjacentHTML('beforeend', buildFreebieCardHTML(rule, idx, 'conditional'));
      newFreebieQtyTotal += parseInt(rule.free_qty) || 1;
    });

    // Also count threshold freebies
    var prevCountOk = true;
    for (var j = 0; j < freebieItems.length; j++) {
      var tierC = (settings.freebie_tiers || [])[j] || {};
      if (tierC.reward_type === 'label') {
        prevCountOk = isTierUnlocked(tierC, cart) && prevCountOk;
        continue;
      }
      var tierMetC = isTierUnlocked(tierC, cart) && prevCountOk;
      prevCountOk = tierMetC;
      if (freebieItems[j].name && isSlotClaimed(j) && tierMetC) {
        newFreebieQtyTotal += 1;
      }
    }

    // Confetti when freebie qty increases — target the last conditional card
    if (newFreebieQtyTotal > prevFreebieQtyTotal && prevFreebieQtyTotal > 0 && settings.enable_confetti !== false) {
      // Find the conditional freebie card that changed (last one rendered)
      var condCards = el.querySelectorAll('.wsc-freebie-item[data-freebie-type="conditional"]');
      var targetCard = condCards.length > 0 ? condCards[condCards.length - 1] : null;
      triggerConfetti(targetCard);
    }
    prevFreebieQtyTotal = newFreebieQtyTotal;
  }

  function countFreebiesInCart() {
    var el = $('wsc-items');
    if (!el) return 0;
    var count = 0;
    el.querySelectorAll('.wsc-freebie-item').forEach(function(card) {
      var ftype = card.getAttribute('data-freebie-type');
      if (ftype === 'conditional') {
        var idx = parseInt(card.getAttribute('data-freebie')) || 0;
        var matched = getMatchedConditionalFreebies();
        if (matched[idx]) count += parseInt(matched[idx].free_qty) || 1;
        else count += 1;
      } else {
        count += 1;
      }
    });
    return count;
  }

  /* ═══════════════════════════════════════
     BILL BREAKDOWN PANEL
     ═══════════════════════════════════════ */

  function toggleBreakdown() {
    var panel = $('wsc-breakdown');
    var icon = document.querySelector('.wsc-ft-breakdown-icon');

    if (panel) {
      // Toggle existing panel
      var isOpen = panel.style.display !== 'none';
      panel.style.display = isOpen ? 'none' : 'block';
      if (icon) icon.style.transform = isOpen ? '' : 'rotate(180deg)';
      if (!isOpen) renderBreakdown();
      return;
    }

    // Create the panel
    var footer = $('wsc-footer');
    var couponRow = $('wsc-coupon');
    if (!footer) return;

    var div = document.createElement('div');
    div.id = 'wsc-breakdown';
    div.className = 'wsc-breakdown';

    // Insert after coupon row
    if (couponRow && couponRow.nextSibling) {
      footer.insertBefore(div, couponRow.nextSibling);
    } else {
      footer.insertBefore(div, footer.querySelector('.wsc-ft-main'));
    }

    if (icon) icon.style.transform = 'rotate(180deg)';
    renderBreakdown();
  }

  function renderBreakdown() {
    var panel = $('wsc-breakdown');
    if (!panel || !cart) return;

    var html = '';
    var subtotal = 0;
    var totalCompare = 0;

    cart.items.forEach(function(item) {
      var meta = productMeta[item.variant_id] || {};
      var cp = meta.compare_at_price || item.original_price;
      var lineTotal = item.price * item.quantity;
      subtotal += lineTotal;
      totalCompare += cp * item.quantity;
      html += '<div class="wsc-bd-line">'
        + '<span class="wsc-bd-name">' + escHTML(item.product_title)
        + (item.quantity > 1 ? ' \u00D7' + item.quantity : '') + '</span>'
        + '<span class="wsc-bd-val">' + formatINR(lineTotal) + '</span>'
        + '</div>';
    });

    var discount = totalCompare - subtotal;

    if (discount > 0) {
      html += '<div class="wsc-bd-line wsc-bd-discount">'
        + '<span class="wsc-bd-name">Product discount</span>'
        + '<span class="wsc-bd-val">-' + formatINR(discount) + '</span>'
        + '</div>';
    }

    // Threshold freebie items in breakdown (sequential + condition-aware)
    {
      var bdPrev = true;
      for (var fi = 0; fi < freebieItems.length; fi++) {
        var bdTier = (settings.freebie_tiers || [])[fi] || {};
        if (bdTier.reward_type === 'label') {
          bdPrev = isTierUnlocked(bdTier, cart) && bdPrev;
          continue;
        }
        var bdMet = isTierUnlocked(bdTier, cart) && bdPrev;
        bdPrev = bdMet;
        if (bdMet && freebieItems[fi].name && isSlotClaimed(fi)) {
          html += '<div class="wsc-bd-line">'
            + '<span class="wsc-bd-name">\uD83C\uDF81 ' + escHTML(freebieItems[fi].name) + '</span>'
            + '<span class="wsc-bd-val" style="color:#2b7a3f;font-weight:600">FREE</span>'
            + '</div>';
        }
      }
    }

    // Conditional freebie items in breakdown
    var matchedCF = getMatchedConditionalFreebies();
    matchedCF.forEach(function(rule) {
      html += '<div class="wsc-bd-line">'
        + '<span class="wsc-bd-name">\uD83C\uDF81 ' + escHTML(rule.name) + '</span>'
        + '<span class="wsc-bd-val" style="color:#2b7a3f;font-weight:600">FREE</span>'
        + '</div>';
    });

    // Cart-level discounts
    var cartDiscounts = cart.cart_level_discount_applications || [];
    cartDiscounts.forEach(function(d) {
      html += '<div class="wsc-bd-line wsc-bd-discount">'
        + '<span class="wsc-bd-name">' + escHTML(d.title) + '</span>'
        + '<span class="wsc-bd-val">-' + formatINR(d.total_allocated_amount) + '</span>'
        + '</div>';
    });

    html += '<div class="wsc-bd-line wsc-bd-total">'
      + '<span class="wsc-bd-name">Total</span>'
      + '<span class="wsc-bd-val">' + formatINR(cart.total_price) + '</span>'
      + '</div>';

    if (discount > 0 || cartDiscounts.length > 0) {
      var totalSaved = discount;
      cartDiscounts.forEach(function(d) { totalSaved += d.total_allocated_amount; });
      html += '<div class="wsc-bd-savings">\uD83C\uDF89 You\'re saving ' + formatINR(totalSaved) + ' on this order!</div>';
    }

    panel.innerHTML = html;
  }

  /* ═══════════════════════════════════════
     PROGRESS BAR
     ═══════════════════════════════════════ */

  function updateProgress() {
    if (!cart) return;
    var total = cart.total_price;

    // Sequential unlock: each milestone only unlocks if previous is unlocked
    var prevUnlocked = true;
    var unlockedCount = 0;
    var nextName = '', nextIcon = '', nextStatusText = '';
    var fillPct = 0;

    for (var i = 0; i < milestones.length; i++) {
      var m = milestones[i];
      var tier = m.tier || {};
      var conditionMet = tier.condition_type ? isTierUnlocked(tier, cart) : total >= m.val;
      var isUnlocked = conditionMet && prevUnlocked;

      if (isUnlocked) {
        unlockedCount++;
        fillPct = ((i + 1) / milestones.length) * 100;
      } else if (!nextName) {
        // Calculate smooth progress toward this next tier
        var tierPct = isTierProgress(tier, cart);
        var segStart = (i / milestones.length) * 100;
        var segEnd = ((i + 1) / milestones.length) * 100;
        fillPct = segStart + (Math.min(tierPct, 90) / 100) * (segEnd - segStart);
        // First locked milestone = next target
        nextName = m.label;
        nextIcon = m.icon;
        if (tier.condition_type) {
          // Use condition-aware status text
          var type = tier.condition_type || 'cart_value';
          var v1 = tier.condition_value || tier.amount || 0;
          var v2 = tier.condition_value2 || 0;
          var totalQty = cart.item_count;
          var uniqueHandles = [];
          cart.items.forEach(function(item) { if (uniqueHandles.indexOf(item.handle) === -1) uniqueHandles.push(item.handle); });
          var uniqueCount = uniqueHandles.length;

          if (!prevUnlocked && conditionMet) {
            nextStatusText = 'Unlock previous gift first to reach <strong>' + escHTML(nextName) + '</strong>';
          } else if (type === 'cart_value') {
            nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">\u20B9' + Math.ceil((v1 - total) / 100) + '</strong> more';
          } else if (type === 'total_qty') {
            var rem = v1 - totalQty;
            nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">' + rem + ' more item' + (rem > 1 ? 's' : '') + '</strong>';
          } else if (type === 'unique_products') {
            var rem2 = v1 - uniqueCount;
            nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">' + rem2 + ' more product' + (rem2 > 1 ? 's' : '') + '</strong>';
          } else if (type === 'value_and_qty') {
            var vMet = total >= v1, qMet = totalQty >= v2;
            if (!vMet && !qMet) nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">' + (v2-totalQty) + ' more item' + ((v2-totalQty)>1?'s':'') + '</strong> (min <strong style="color:#2b7a3f">\u20B9' + Math.ceil((v1-total)/100) + '</strong>)';
            else if (!vMet) nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">\u20B9' + Math.ceil((v1-total)/100) + '</strong> more';
            else nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">' + (v2-totalQty) + ' more item' + ((v2-totalQty)>1?'s':'') + '</strong>';
          } else if (type === 'value_and_unique') {
            var vMet2 = total >= v1, uMet = uniqueCount >= v2;
            if (!vMet2 && !uMet) nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">' + (v2-uniqueCount) + ' more product' + ((v2-uniqueCount)>1?'s':'') + '</strong> (min <strong style="color:#2b7a3f">\u20B9' + Math.ceil((v1-total)/100) + '</strong>)';
            else if (!vMet2) nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">\u20B9' + Math.ceil((v1-total)/100) + '</strong> more';
            else nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">' + (v2-uniqueCount) + ' more product' + ((v2-uniqueCount)>1?'s':'') + '</strong>';
          }
        } else {
          var remaining = Math.ceil((m.val - total) / 100);
          nextStatusText = '\uD83C\uDF81 Unlock <strong>' + escHTML(nextName) + '</strong> \u2014 add <strong style="color:#2b7a3f">\u20B9' + remaining + '</strong> more';
        }
      }
      prevUnlocked = isUnlocked;
    }

    // Update fill bar using actual dot positions (not percentages)
    var fill = $('wsc-progress-fill');
    var track = document.querySelector('.wsc-progress-track');
    var dotRow = document.getElementById('wsc-progress-row');
    if (fill && track && dotRow) {
      var dots = dotRow.querySelectorAll('.wsc-progress-ms');
      var trackRect = track.getBoundingClientRect();
      var trackWidth = trackRect.width;

      if (dots.length > 0 && trackWidth > 0) {
        var fillPx = 0;
        // Find the last unlocked dot and the next locked dot
        var lastUnlockedIdx = -1;
        var nextLockedIdx = -1;
        prevUnlocked = true;
        for (var fi = 0; fi < milestones.length; fi++) {
          var fm = milestones[fi];
          var fTier = fm.tier || {};
          var fCondMet = fTier.condition_type ? isTierUnlocked(fTier, cart) : total >= fm.val;
          var fUnlocked = fCondMet && prevUnlocked;
          if (fUnlocked) lastUnlockedIdx = fi;
          else if (nextLockedIdx === -1) nextLockedIdx = fi;
          prevUnlocked = fUnlocked;
        }

        if (lastUnlockedIdx >= 0 && dots[lastUnlockedIdx]) {
          // Fill to center of last unlocked dot
          var dotRect = dots[lastUnlockedIdx].getBoundingClientRect();
          fillPx = (dotRect.left + dotRect.width / 2) - trackRect.left;
        }

        if (nextLockedIdx >= 0 && nextLockedIdx < dots.length && dots[nextLockedIdx]) {
          // Add smooth progress toward next dot
          var nextDotRect = dots[nextLockedIdx].getBoundingClientRect();
          var nextDotCenter = (nextDotRect.left + nextDotRect.width / 2) - trackRect.left;
          var prevDotCenter = lastUnlockedIdx >= 0 ? ((dots[lastUnlockedIdx].getBoundingClientRect().left + dots[lastUnlockedIdx].getBoundingClientRect().width / 2) - trackRect.left) : 0;
          var tierProg = isTierProgress(milestones[nextLockedIdx].tier || {}, cart);
          fillPx = prevDotCenter + (Math.min(tierProg, 90) / 100) * (nextDotCenter - prevDotCenter);
        } else if (lastUnlockedIdx === milestones.length - 1) {
          // All unlocked — fill to end
          fillPx = trackWidth;
        }

        fill.style.width = Math.max(0, Math.min(fillPx, trackWidth)) + 'px';
      } else {
        fill.style.width = '0';
      }
    }

    // Update message
    var msgEl = document.getElementById('wsc-progress-msg');
    if (msgEl) {
      if (unlockedCount === milestones.length) {
        msgEl.innerHTML = '<span class="wsc-green">All rewards unlocked! \uD83C\uDF89</span>';
      } else {
        msgEl.innerHTML = nextStatusText;
      }
    }

    // Render milestone dots dynamically from milestones[]
    var dotRow = document.getElementById('wsc-progress-row');
    if (dotRow) {
      var dotsHtml = '';
      prevUnlocked = true;
      var foundNext = false;
      for (var di = 0; di < milestones.length; di++) {
        var dm = milestones[di];
        var dTier = dm.tier || {};
        var dCondMet = dTier.condition_type ? isTierUnlocked(dTier, cart) : total >= dm.val;
        var dUnlocked = dCondMet && prevUnlocked;
        var dIsNext = !dUnlocked && !foundNext;
        var dotCls = 'wsc-progress-ms';
        if (dUnlocked) dotCls += ' wsc-ms-done';
        else if (dIsNext) { dotCls += ' wsc-ms-next'; foundNext = true; }
        
        // Dashboard "dot_above_text" — tiny label rendered ABOVE everything on the dot
        var dotAboveHtml = '';
        if (dTier.dot_above_text) {
          dotAboveHtml = '<div class="wsc-ms-above">' + escHTML(dTier.dot_above_text) + '</div>';
        }

        // Dot label: reward name + amount only (condition explained in message bar)
        // Amount ABOVE emoji
        var dotAmtAbove = '';
        var dotSub = dTier.dot_subtitle || '';
        if (dotSub) {
          dotAmtAbove = '<div style="font-size:8px;color:' + (dUnlocked ? '#2b7a3f' : (dIsNext ? '#a3164e' : '#aaa')) + ';font-weight:' + (dUnlocked ? '600' : '700') + ';margin-bottom:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + escHTML(dotSub) + '</div>';
        } else {
          var dotAmt = dTier.condition_value || dTier.amount || 0;
          if (dotAmt > 0) dotAmtAbove = '<div style="font-size:8px;color:' + (dUnlocked ? '#2b7a3f' : (dIsNext ? '#a3164e' : '#aaa')) + ';font-weight:' + (dUnlocked ? '600' : '700') + ';margin-bottom:0">\u20B9' + Math.round(dotAmt / 100).toLocaleString('en-IN') + '</div>';
        }

        // Name BELOW emoji
        var dotNameBelow = '<div style="font-size:8px;font-weight:600;color:' + (dUnlocked ? '#2b7a3f' : (dIsNext ? '#a3164e' : '#aaa')) + ';overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-top:2px">' + escHTML(dm.label) + '</div>';
        
        dotsHtml += '<div class="' + dotCls + '">'
          + dotAboveHtml
          + dotAmtAbove
          + '<div class="wsc-progress-em">' + (dm.icon || '\uD83C\uDF81') + '</div>'
          + dotNameBelow
          + '</div>';
        prevUnlocked = dUnlocked;
      }
      dotRow.innerHTML = dotsHtml;
    }

    // Confetti on new milestone
    if (initialized && unlockedCount > prevMilestone && settings.enable_confetti !== false) {
      triggerConfetti();
    }
    prevMilestone = unlockedCount;
  }

  /* ═══════════════════════════════════════
     FREEBIES
     ═══════════════════════════════════════ */

  function updateFreebies() {
    if (!cart) return;
    var total = cart.total_price;
    var unlocked = 0;
    var claimed = 0;
    var claimedDropped = false;

    var prevTierUnlocked = true;
    freebieItems.forEach(function(fb, i) {
      var tier = (settings.freebie_tiers || [])[i] || {};
      // Label-only milestones don't show in freebie section
      if (tier.reward_type === 'label') {
        // Still track sequential unlock state
        var met = isTierUnlocked(tier, cart);
        prevTierUnlocked = met && prevTierUnlocked;
        return;
      }
      if (!fb.name || !fb.handle) { return; }
      var fbMet = isTierUnlocked(tier, cart) && prevTierUnlocked;
      prevTierUnlocked = fbMet;
      if (fbMet) {
        unlocked++;
        if (isSlotClaimed(i)) claimed++;
      } else {
        // Cart dropped below a claimed tier — unclaim and sync the attribute
        if (isSlotClaimed(i)) claimedDropped = true;
        clearSlotClaimed(i);
      }
    });

    if (claimedDropped) syncFreebieAttributes();

    // Re-render the slot bar
    renderFreebieSlots();

    // Re-render cart items
    renderFreebieCartItems();

    // Update badge
    var badgeEl = $('wsc-fb-badge');
    if (badgeEl) {
      if (claimed > 0 && claimed === unlocked) {
        badgeEl.textContent = claimed + ' added';
      } else if (unlocked > 0) {
        badgeEl.textContent = 'Tap to claim';
      } else {
        badgeEl.textContent = 'locked';
      }
    }

    // Wiggle animation — always wiggle freebie accordion
    var accordionHdr = badgeEl ? badgeEl.closest('[data-wsc-accordion]') : null;
    if (accordionHdr) {
      accordionHdr.classList.add('wsc-accordion-wiggle');
    }
  }

  /* ═══════════════════════════════════════
     FOOTER
     ═══════════════════════════════════════ */

  function updateFooter() {
    if (!cart) return;

    var totalEl = $('wsc-ft-total');
    if (totalEl) totalEl.textContent = formatINR(cart.total_price);

    var origTotal = 0;
    cart.items.forEach(function(item) {
      var meta = productMeta[item.variant_id] || {};
      var cp = meta.compare_at_price || item.original_price;
      origTotal += cp * item.quantity;
    });
    var savings = origTotal - cart.total_price;

    var origEl = $('wsc-ft-orig');
    if (origEl) {
      if (savings > 0) { origEl.textContent = formatINR(origTotal); origEl.style.display = ''; }
      else { origEl.style.display = 'none'; }
    }

    var freebieCount = countFreebiesInCart();
    var displayCount = cart.item_count + freebieCount;

    var countEl = $('wsc-ft-count');
    if (countEl) {
      var txt = displayCount + ' item' + (displayCount !== 1 ? 's' : '');
      if (freebieCount > 0) txt += ' (' + freebieCount + ' FREE)';
      if (savings > 0) txt += ' \u00B7 Save ' + formatINR(savings);
      countEl.textContent = txt;
    }

    var hdrCount = $('wsc-hdr-count');
    if (hdrCount) hdrCount.textContent = '(' + displayCount + ')';

    // Disable checkout CTA on an empty cart (goToCheckout already guards; this
    // makes the state visible). Never fight the in-flight "Processing..." state.
    var ctaEl = $('wsc-checkout-btn');
    if (ctaEl && ctaEl.textContent.indexOf('Processing') === -1) {
      ctaEl.disabled = (cart.item_count === 0);
    }

    document.querySelectorAll('.m-cart-count-bubble, [data-cart-count], .cart-count-badge').forEach(function(el) {
      el.textContent = displayCount;
    });

    updateCoupon();

    // Update breakdown if open
    var panel = $('wsc-breakdown');
    if (panel && panel.style.display !== 'none') renderBreakdown();
  }

  function updateCoupon() {
    var couponEl = $('wsc-coupon');
    if (!couponEl || !cart) return;
    var discounts = cart.cart_level_discount_applications || [];
    var codeEl = couponEl.querySelector('.wsc-coupon-code');
    var savedEl = couponEl.querySelector('.wsc-coupon-saved');
    if (discounts.length > 0) {
      if (codeEl) codeEl.textContent = discounts[0].title;
      if (savedEl) savedEl.textContent = '-' + formatINR(discounts[0].total_allocated_amount) + ' off';
    }
  }

  /* ═══════════════════════════════════════
     TIMERS — with expiry handling
     ═══════════════════════════════════════ */

  function initTimers() {
    // Dashboard kill-switch — hide timer chips and skip all countdowns
    if (settings.enable_urgency_timers === false) {
      document.querySelectorAll('.wsc-coupon-timer, .wsc-fb-timer').forEach(function(el) { hideEl(el); });
      var flashT = $('wsc-sp-flash-timer');
      if (flashT) hideEl(flashT);
      return;
    }
    // ONE honest shared countdown: every chip shows the SAME number, from a single
    // session deadline. It expires once — no restarts, no fake urgency cycles.
    var totalSecs = parseInt(settings.coupon_timer_seconds) || 600;
    var remaining = getSessionTimer('shared', totalSecs);
    startTimer('wsc-coupon-time', remaining, onSharedExpiry);
    // Free-gift tiers are threshold-based, not time-based — a countdown there implied
    // the gifts expire, which broke the honest-timers rule. Chip removed (2026-07-07).
    document.querySelectorAll('.wsc-fb-timer').forEach(function(el) { hideEl(el); });
    startTimer('wsc-sp-flash-timer', remaining, null);
  }

  function getSessionTimer(key, def) {
    var sk = 'wsc_t_' + key;
    try {
      var saved = sessionStorage.getItem(sk);
      if (saved) {
        var d = JSON.parse(saved);
        var rem = d.dur - Math.floor((Date.now() - d.at) / 1000);
        return rem > 0 ? rem : 0;
      }
      sessionStorage.setItem(sk, JSON.stringify({ dur: def, at: Date.now() }));
    } catch(e) {}
    return def;
  }

  function startTimer(elId, secs, onExpiry) {
    timerSecs[elId] = secs;
    if (timerIDs[elId]) clearInterval(timerIDs[elId]);
    if (secs <= 0) { if (onExpiry) onExpiry(); renderTimer(elId); return; }
    renderTimer(elId);
    timerIDs[elId] = setInterval(function() {
      if (--timerSecs[elId] <= 0) {
        timerSecs[elId] = 0;
        clearInterval(timerIDs[elId]);
        if (onExpiry) onExpiry();
      }
      renderTimer(elId);
    }, 1000);
  }

  function renderTimer(elId) {
    var el = $(elId);
    if (!el) return;
    var s = timerSecs[elId] || 0;
    var m = Math.floor(s / 60);
    el.textContent = (m < 10 ? '0' : '') + m + ':' + ((s % 60) < 10 ? '0' : '') + (s % 60);
  }

  // Shared expiry: hide every timer chip (offers stay valid — only the countdown disappears)
  function onSharedExpiry() {
    document.querySelectorAll('.wsc-coupon-timer, .wsc-fb-timer').forEach(function(el) { hideEl(el); });
    var flashT = $('wsc-sp-flash-timer');
    if (flashT) hideEl(flashT);
    var strip = document.querySelector('.wsc-sp-offer-strip-red');
    if (strip) strip.style.display = 'none';
  }

  /* ═══════════════════════════════════════
     CONFETTI
     ═══════════════════════════════════════ */

  function triggerConfetti(targetCard) {
    // Find freebie card to localize confetti burst
    var card = targetCard || document.querySelector('.wsc-freebie-item');
    var drawer = document.getElementById('wsc-drawer');
    if (!drawer) return;
    var drawerRect = drawer.getBoundingClientRect();

    var c = document.createElement('canvas');
    c.style.cssText = 'position:fixed;top:' + drawerRect.top + 'px;left:' + drawerRect.left + 'px;width:' + drawerRect.width + 'px;height:' + drawerRect.height + 'px;z-index:999999;pointer-events:none;';
    document.body.appendChild(c);
    var ctx = c.getContext('2d');
    c.width = drawerRect.width; c.height = drawerRect.height;

    // Origin = center of freebie card (or center of drawer if no card)
    var originX = c.width / 2;
    var originY = c.height / 2;
    if (card) {
      var cardRect = card.getBoundingClientRect();
      originX = (cardRect.left - drawerRect.left) + cardRect.width / 2;
      originY = (cardRect.top - drawerRect.top) + cardRect.height / 2;
    }

    // Brief glow on freebie card
    if (card) {
      card.style.transition = 'box-shadow 0.15s';
      card.style.boxShadow = '0 0 20px rgba(43, 122, 63,.4), 0 0 40px rgba(43, 122, 63,.2)';
      setTimeout(function() { card.style.boxShadow = ''; }, 800);
    }

    var colors = ['#052a49','#8ecc06','#a3164e','#ffd028','#c44e7a','#fff','#eef7e0','#8ecc06'];
    var particles = [];
    for (var i = 0; i < 60; i++) {
      var angle = Math.random() * Math.PI * 2;
      var speed = Math.random() * 6 + 2;
      particles.push({
        x: originX + (Math.random() - .5) * 40,
        y: originY + (Math.random() - .5) * 20,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 3,
        w: Math.random() * 6 + 2, h: Math.random() * 4 + 2,
        color: colors[i % colors.length],
        rot: Math.random() * 360, rs: (Math.random() - .5) * 20, op: 1,
        circle: Math.random() > 0.6
      });
    }
    (function draw() {
      ctx.clearRect(0, 0, c.width, c.height);
      var alive = false;
      particles.forEach(function(p) {
        p.x += p.vx; p.vy += .15; p.y += p.vy;
        p.vx *= 0.98; p.rot += p.rs; p.op -= 0.015;
        if (p.op <= 0) return;
        alive = true;
        ctx.save(); ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.globalAlpha = Math.max(0, p.op);
        ctx.fillStyle = p.color;
        if (p.circle) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2); ctx.fill(); }
        else { ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); }
        ctx.restore();
      });
      if (alive) requestAnimationFrame(draw); else c.remove();
    })();
  }

  /* ═══════════════════════════════════════
     REFRESH
     ═══════════════════════════════════════ */




  function openWellnessAccordion() {
    var wellnessHdr = getWellnessHeader();
    if (!wellnessHdr) return;
    [wellnessHdr].forEach(function(hdr) {
      var body = hdr.nextElementSibling;
      if (!body) return;
      // Mark user interaction — cancel any peek close timer
      userOpenedWellness = true;
      if (peekCloseTimer) { clearTimeout(peekCloseTimer); peekCloseTimer = null; }
      // Stop wiggle + remove finger
      hdr.classList.remove('wsc-accordion-wiggle');
      var finger = hdr.querySelector('.wsc-peek-finger');
      if (finger) finger.remove();
      // Open via class
      body.classList.add('wsc-accordion-expanded');
      var arrow = hdr.querySelector('.wsc-accordion-arrow');
      if (arrow) arrow.classList.add('wsc-arrow-open');
      // Scroll after opening
      setTimeout(function() {
        hdr.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    });
  }

  function renderInlineTeaser() {
    // HIDDEN (owner request): "Dr. Nishant's prescription" side-cart strip.
    // Restore by deleting the next two lines.
    var old = document.getElementById('wsc-inline-teaser'); if (old) old.remove();
    return;
    // Remove existing teaser
    var old = document.getElementById('wsc-inline-teaser');
    if (old) old.remove();

    if (!settings.enable_wellness || wellnessGoals.length === 0 || !cart || cart.items.length === 0) return;

    // Find best matching goal
    var bestGoal = wellnessGoals[0];
    var bestCount = 0;
    wellnessGoals.forEach(function(wg) {
      var c = 0;
      (wg.slots || []).forEach(function(slot) {
        if (cart.items.some(function(item) { return String(item.variant_id) === String(slot.variant_id); })) c++;
      });
      if (c > bestCount) { bestCount = c; bestGoal = wg; }
    });

    var totalSlots = (bestGoal.slots || []).filter(function(s) { return !!s.product_title; }).length;
    var inCartCount = 0;
    (bestGoal.slots || []).forEach(function(slot) {
      if (cart.items.some(function(item) { return String(item.variant_id) === String(slot.variant_id); })) inCartCount++;
    });

    // Don't show if routine is complete
    if (inCartCount >= totalSlots && totalSlots > 0) return;
    // Don't show if no products in cart match any goal
    if (bestCount === 0 && cart.items.length > 0) return;

    var remaining = totalSlots - inCartCount;
    var subtitle = settings.wellness_teaser_text || ('Complete your ' + (bestGoal.label || 'wellness').toLowerCase() + ' routine \u00B7 ' + remaining + ' more \u2192 FREE gift \uD83C\uDF81');

    var html = '<div id="wsc-inline-teaser" style="margin:4px 12px;padding:6px 10px;border-radius:6px;background:linear-gradient(135deg,#ffffff,#f5e6ec);border:1.5px dashed rgba(163,22,78,.3);display:flex;align-items:center;gap:6px;cursor:pointer">'
      + '<div style="font-size:14px;flex-shrink:0">\uD83D\uDCCB</div>'
      + '<div style="flex:1;font-size:10px;font-weight:600;color:#a3164e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">Dr. Nishant\u2019s prescription \u00B7 <span style="color:#c44e7a;font-weight:500">' + escHTML(subtitle) + '</span></div>'
      + '<div style="font-size:8px;padding:3px 7px;background:#052a49;color:#fff;border-radius:4px;font-weight:700;flex-shrink:0">View</div>'
      + '</div>';

    // Insert after cart items, before first separator
    // Insert after cart items area, before first separator
    var items = document.getElementById('wsc-items');
    if (items) {
      items.insertAdjacentHTML('afterend', html);
    } else {
      var body = document.getElementById('wsc-body');
      if (body) body.insertAdjacentHTML('afterbegin', html);
    }
  }

  function renderWellnessTimeline(goalId) {
    var section = document.getElementById('wsc-wellness-section');
    if (!section || !settings.enable_wellness || wellnessGoals.length === 0) {
      if (section) section.innerHTML = '';
      return;
    }
    activeGoalId = goalId || (wellnessGoals[0] && wellnessGoals[0].id);

    var goal = null;
    for (var g = 0; g < wellnessGoals.length; g++) {
      if (wellnessGoals[g].id === activeGoalId) { goal = wellnessGoals[g]; break; }
    }
    if (!goal) return;

    var html = '';

    // Goal pills
    if (wellnessGoals.length > 1) {
      html += '<div class="wsc-goal-pills">';
      wellnessGoals.forEach(function(wg) {
        var cls = wg.id === activeGoalId ? 'wsc-goal-pill wsc-goal-active' : 'wsc-goal-pill';
        html += '<div class="' + cls + '" data-goal-id="' + escHTML(wg.id) + '">'
          + '<span class="wsc-goal-icon">' + (wg.icon || '') + '</span>' + escHTML(wg.label)
          + '</div>';
      });
      html += '</div>';
    }

    // Timeline
    html += '<div class="wsc-timeline">';
    var slotsInCart = 0;
    var totalSlots = 0;
    (goal.slots || []).forEach(function(slot) {
      if (!slot.product_title) return;
      totalSlots++;
      var inCart = cart && cart.items.some(function(item) { return String(item.variant_id) === String(slot.variant_id); });
      if (inCart) slotsInCart++;

      var pctOff = slot.compare_price > slot.price ? Math.round((1 - slot.price / slot.compare_price) * 100) : 0;

      html += '<div class="wsc-tl-step">';
      html += '<div class="wsc-tl-dot' + (inCart ? ' wsc-tl-done' : '') + '">' + (inCart ? '\u2713' : '') + '</div>';
      html += '<div class="wsc-tl-time"><span class="wsc-tl-emoji">' + (slot.time_emoji || '') + '</span> ' + escHTML(slot.time_label) + '</div>';
      html += '<div class="wsc-tl-card' + (inCart ? ' wsc-tl-incart' : '') + (slot.offer_enabled ? ' wsc-tl-card-has-strip' : '') + '"' + (slot.product_handle ? ' data-handle="' + escHTML(slot.product_handle) + '" style="cursor:pointer"' : '') + '>';

      if (slot.product_image) {
        html += '<div class="wsc-tl-card-img"><img src="' + escHTML(slot.product_image) + (slot.product_image.indexOf('?') !== -1 ? '&width=80' : '?width=80') + '" style="width:100%;height:100%;object-fit:cover;border-radius:6px"></div>';
      } else {
        html += '<div class="wsc-tl-card-img">' + (slot.time_emoji || '\uD83D\uDCE6') + '</div>';
      }

      html += '<div class="wsc-tl-card-info">';
      html += '<div class="wsc-tl-card-name">' + escHTML(slot.product_title) + '</div>';
      html += '<div class="wsc-tl-card-desc">' + escHTML(slot.description) + '</div>';
      html += '<div class="wsc-tl-card-prices">';
      html += '<span class="wsc-tl-final">' + formatINR(slot.price) + '</span>';
      if (slot.compare_price > slot.price) {
        html += '<span class="wsc-tl-orig">' + formatINR(slot.compare_price) + '</span>';
        if (pctOff > 0) html += '<span class="wsc-tl-off">' + pctOff + '% OFF</span>';
      }
      if (slot.tag) html += '<span class="wsc-tl-tag wsc-tl-tag-' + escHTML(slot.tag_color || 'immunity') + '">' + escHTML(slot.tag) + '</span>';
      html += '</div></div>';

      if (inCart) {
        html += '<div class="wsc-tl-card-status">In Cart \u2713</div>';
      } else {
        html += '<button class="wsc-tl-card-add" type="button" data-variant="' + (slot.variant_id || '') + '">+ Add</button>';
      }

      html += '</div>';

      if (slot.offer_enabled && slot.offer_text) {
        html += '<div class="wsc-tl-offer-strip wsc-tl-offer-strip-' + escHTML(slot.offer_color || 'green') + '">' + escHTML(slot.offer_text) + '</div>';
      }

      html += '</div>';
    });
    html += '</div>';

    // Routine reward
    if (goal.reward_enabled && goal.reward_text) {
      var isComplete = totalSlots > 0 && slotsInCart === totalSlots;
      html += '<div class="wsc-routine-reward' + (isComplete ? ' wsc-rr-complete' : '') + '">';
      html += '<div style="display:flex;justify-content:space-between;align-items:center">';
      html += '<div>' + (isComplete ? '\uD83C\uDF89 ' : '\uD83C\uDF81 ') + escHTML(goal.reward_text) + '</div>';
      html += '<div style="display:flex;gap:6px;align-items:center;flex-shrink:0">';
      if (goal.reward_value) html += '<span class="wsc-rr-value" style="font-size:8px">' + escHTML(goal.reward_value) + '</span>';
      if (totalSlots > 0) html += '<span style="font-size:8px;background:' + (isComplete ? '#2b7a3f' : '#e0e0e0') + ';color:' + (isComplete ? '#fff' : '#666') + ';padding:1px 6px;border-radius:8px;font-weight:700">' + slotsInCart + '/' + totalSlots + '</span>';
      html += '</div></div>';
      html += '</div>';
    }

    section.innerHTML = html;

    // Badge: "locked" is misleading for an upsell — show routine progress once
    // anything matches, otherwise invite the tap. Peek's "Tap to explore" only
    // ever replaces the invite text, never a progress count.
    var wBadge = $('wsc-wellness-badge');
    if (wBadge) {
      if (totalSlots > 0 && slotsInCart > 0) {
        wBadge.textContent = slotsInCart + '/' + totalSlots + ' in cart';
        wBadge.style.background = '#eef7e0';
        wBadge.style.color = '#2b7a3f';
      } else if (wBadge.textContent.trim() === 'locked' || wBadge.textContent.indexOf('/') !== -1) {
        // Nothing matches anymore (or never did) — show the invite, not a stale count
        wBadge.textContent = 'Tap to explore';
      }
    }
  }

  // Collection-based upsell fallback — fetched once per page load, cached
  var _wscUpsellFetchStarted = false;
  var _wscUpsellProducts = null;

  function fetchCollectionUpsell() {
    if (_wscUpsellFetchStarted) return;
    _wscUpsellFetchStarted = true;
    var handle = settings.upsell_collection_handle;
    var limit = parseInt(settings.upsell_max_products) || 6;
    fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit, { credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('/collections/' + handle + '/products.json responded ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var prods = (data && Array.isArray(data.products)) ? data.products : [];
        _wscUpsellProducts = prods.slice(0, limit).map(function(p) {
          var v = (p.variants && p.variants[0]) || {};
          return {
            product_title: p.title || '',
            variant_id: v.id || '',
            price: Math.round(parseFloat(v.price || 0) * 100) || 0,
            compare_price: v.compare_at_price ? (Math.round(parseFloat(v.compare_at_price) * 100) || 0) : 0,
            product_image: (p.images && p.images[0] && p.images[0].src) || '',
            product_handle: p.handle || ''
          };
        }).filter(function(p) { return p.product_title && p.variant_id; });
        if (_wscUpsellProducts.length > 0) renderAlsoBought();
      })
      .catch(function(e) {
        // On fetch failure the section simply stays hidden
        console.error('WSC: collection upsell fetch failed', e);
      });
  }

  function renderAlsoBought() {
    var section = document.getElementById('wsc-also-bought-section');
    var divider = document.getElementById('wsc-ups-divider');
    var products = settings.also_bought_products || [];
    var usingCollection = false;

    // No manual products configured → fall back to upsell_collection_handle
    if (products.length === 0 && settings.enable_upsell !== false && settings.upsell_collection_handle) {
      if (_wscUpsellProducts && _wscUpsellProducts.length > 0) {
        products = _wscUpsellProducts;
        usingCollection = true;
      } else {
        fetchCollectionUpsell(); // async — re-renders when products arrive
      }
    }

    var upsEnabled = usingCollection ? true : settings.enable_also_bought;
    if (!section || !upsEnabled || products.length === 0) {
      if (section) section.innerHTML = '';
      if (divider) divider.style.display = 'none';
      return;
    }
    if (divider) divider.style.display = '';

    var html = '<div class="wsc-sp-head">' + escHTML(settings.upsell_title || settings.also_bought_title || 'Customers Also Bought') + '</div>';

    products.forEach(function(prod) {
      if (!prod.product_title) return;
      var inCart = cart && cart.items.some(function(item) { return String(item.variant_id) === String(prod.variant_id); });
      var pctOff = prod.compare_price > prod.price ? Math.round((1 - prod.price / prod.compare_price) * 100) : 0;

      html += '<div class="wsc-sp-card' + (prod.offer_enabled ? ' wsc-sp-card-has-strip' : '') + '"' + (prod.product_handle ? ' data-handle="' + escHTML(prod.product_handle) + '" style="cursor:pointer"' : '') + '>';

      html += '<div class="wsc-sp-card-img">';
      if (prod.product_image) {
        html += '<img src="' + escHTML(prod.product_image) + (prod.product_image.indexOf('?') !== -1 ? '&width=80' : '?width=80') + '" style="width:100%;height:100%;object-fit:cover;border-radius:6px">';
      } else {
        html += '\uD83D\uDCE6';
      }
      if (pctOff > 0) html += '<div class="wsc-sp-badge">' + pctOff + '% OFF</div>';
      html += '</div>';

      html += '<div class="wsc-sp-card-info">';
      html += '<div class="wsc-sp-card-name">' + escHTML(prod.product_title) + '</div>';
      if (prod.tag) {
        html += '<div class="wsc-sp-card-tags"><span class="wsc-tl-tag wsc-tl-tag-' + escHTML(prod.tag_color || 'immunity') + '">' + escHTML(prod.tag) + '</span></div>';
      }
      if (prod.social_text) {
        html += '<div class="wsc-sp-card-social"><span class="wsc-sp-stars">\u2605\u2605\u2605\u2605\u2605</span> ' + escHTML(prod.social_text) + '</div>';
      }
      html += '<div class="wsc-sp-card-prices">';
      html += '<span class="wsc-sp-final">' + formatINR(prod.price) + '</span>';
      if (prod.compare_price > prod.price) {
        html += '<span class="wsc-sp-orig">' + formatINR(prod.compare_price) + '</span>';
        var spPctOff = Math.round((1 - prod.price / prod.compare_price) * 100); html += '<span class="wsc-sp-save">' + spPctOff + '% OFF</span>';
      }
      html += '</div></div>';

      if (inCart) {
        html += '<div class="wsc-tl-card-status" style="align-self:center">In Cart \u2713</div>';
      } else {
        html += '<button class="wsc-sp-card-add" type="button" data-variant="' + (prod.variant_id || '') + '">+ Add</button>';
      }

      html += '</div>';

      if (prod.offer_enabled && prod.offer_text) {
        html += '<div class="wsc-sp-offer-strip wsc-sp-offer-strip-' + escHTML(prod.offer_color || 'green') + '">' + escHTML(prod.offer_text) + '</div>';
      }
    });

    section.innerHTML = html;
  }

  /* ═══════════════════════════════════════
     VOLUME TIER — "Buy More, Save More"
     Real quantity changes via changeQty(); the matching automatic
     discount is configured by the merchant in Shopify.
     ═══════════════════════════════════════ */

  function renderVolumeTier() {
    var box = $('wsc-volume-tier');
    if (!box) return;
    var vid = settings.volume_product_variant_id;
    if (settings.enable_volume_tier !== true || !vid || !cart || !cart.items || cart.items.length === 0) {
      box.innerHTML = '';
      hideEl(box);
      return;
    }
    var item = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(vid)) { item = cart.items[i]; break; }
    }
    if (!item) {
      box.innerHTML = '';
      hideEl(box);
      return;
    }

    var d2 = parseFloat(settings.volume_tier_2_discount) || 0;
    var d3 = parseFloat(settings.volume_tier_3_discount) || 0;
    var vtTitle = settings.volume_product_title || item.product_title || '';
    var opts = [{ q: 1, save: 0 }, { q: 2, save: d2 }, { q: 3, save: d3 }];

    var html = '<div class="wsc-vt-head">\uD83D\uDD25 Buy More, Save More</div>'
      + (vtTitle ? '<div class="wsc-vt-name">' + escHTML(vtTitle) + '</div>' : '')
      + '<div class="wsc-vt-opts">';
    opts.forEach(function(o) {
      var active = item.quantity === o.q;
      html += '<button type="button" class="wsc-vt-opt' + (active ? ' wsc-vt-active' : '')
        + '" data-vt-key="' + item.key + '" data-vt-qty="' + o.q + '">'
        + '<span class="wsc-vt-qty">' + o.q + '\u00D7' + (active ? ' \u2713' : '') + '</span>'
        + '<span class="wsc-vt-price">' + formatINR(item.price * o.q) + '</span>'
        + (o.save > 0 ? '<span class="wsc-vt-save">Save ' + o.save + '%</span>' : '')
        + '</button>';
    });
    html += '</div>';
    if (d2 > 0 || d3 > 0) html += '<div class="wsc-vt-note">Discount applies at checkout</div>';

    box.innerHTML = html;
    showEl(box, 'block');
  }

  /* ═══════════════════════════════════════
     BUNDLE NUDGE — "Complete the combo"
     Adds the missing real item via addToCart(); the combo discount is
     configured by the merchant in Shopify.
     ═══════════════════════════════════════ */

  function renderBundleNudge() {
    var box = $('wsc-bundle-nudge');
    if (!box) return;
    var aId = settings.bundle_product_a_variant_id;
    var bId = settings.bundle_product_b_variant_id;
    if (settings.enable_bundle_nudge !== true || !aId || !bId || !cart || !cart.items || cart.items.length === 0) {
      box.innerHTML = '';
      hideEl(box);
      return;
    }
    var aIn = cart.items.some(function(it) { return String(it.variant_id) === String(aId); });
    var bIn = cart.items.some(function(it) { return String(it.variant_id) === String(bId); });
    // Show only when exactly one of the two is in the cart
    if (aIn === bIn) {
      box.innerHTML = '';
      hideEl(box);
      return;
    }
    var missingId = aIn ? bId : aId;
    var comboPrice = parseFloat(settings.bundle_combo_price) || 0;

    var html = '<div class="wsc-bn-head">' + escHTML(settings.bundle_title || 'Complete the combo')
      + (settings.bundle_savings_text ? '<span class="wsc-bn-pill">' + escHTML(settings.bundle_savings_text) + '</span>' : '')
      + '</div>'
      + '<div class="wsc-bn-products">'
      + '<span class="wsc-bn-prod' + (aIn ? ' wsc-bn-incart' : '') + '">' + (aIn ? '\u2713 ' : '') + escHTML(settings.bundle_product_a_title || 'Product A') + '</span>'
      + '<span class="wsc-bn-plus">+</span>'
      + '<span class="wsc-bn-prod' + (bIn ? ' wsc-bn-incart' : '') + '">' + (bIn ? '\u2713 ' : '') + escHTML(settings.bundle_product_b_title || 'Product B') + '</span>'
      + '</div>'
      + '<div class="wsc-bn-foot">'
      + (comboPrice > 0 ? '<span class="wsc-bn-price">\u20B9' + comboPrice.toLocaleString('en-IN') + '</span>' : '<span></span>')
      + '<button type="button" class="wsc-bn-add" data-bn-variant="' + escHTML(String(missingId)) + '">Add Combo</button>'
      + '</div>'
      + (comboPrice > 0 ? '<div class="wsc-bn-note">Combo discount applies at checkout</div>' : '');

    box.innerHTML = html;
    showEl(box, 'block');
  }


  // Wellness auto-peek: briefly show preview then collapse
  function wellnessAutoPeek() {
    var hdr = getWellnessHeader();
    var body = hdr ? hdr.nextElementSibling : null;
    if (!hdr || !body) return;
    if (userOpenedWellness) return;

    // Ensure closed first
    body.classList.remove('wsc-accordion-expanded');
    var arrow = hdr.querySelector('.wsc-accordion-arrow');
    if (arrow) arrow.classList.remove('wsc-arrow-open');

    // Add wiggle (if enabled)
    if (settings.wellness_wiggle !== false) hdr.classList.add('wsc-accordion-wiggle');

    // Peek open
    setTimeout(function() {
      if (userOpenedWellness) return;
      body.classList.add('wsc-accordion-expanded');
      if (arrow) arrow.classList.add('wsc-arrow-open');

    }, 500);

    // Close at 2.5s (2s visible) + show finger
    var peekDur = (settings.wellness_peek_duration || 4000) + 500;
    if (peekCloseTimer) clearTimeout(peekCloseTimer);
    peekCloseTimer = setTimeout(function() {
      if (userOpenedWellness) return;
      body.classList.remove('wsc-accordion-expanded');
      if (arrow) arrow.classList.remove('wsc-arrow-open');
      hdr.classList.remove('wsc-accordion-wiggle');
      var badge = hdr.querySelector('.wsc-accordion-badge');
      if (badge && badge.textContent.indexOf('/') === -1) {
        badge.textContent = 'Tap to explore';
        badge.style.background = '#eef7e0';
        badge.style.color = '#2b7a3f';
      }
      peekCloseTimer = null;

      // Show tap finger animation after 300ms
      setTimeout(function() {
        if (userOpenedWellness) return;
        if (settings.wellness_finger === false) return;
        // Remove existing finger if any
        var oldFinger = hdr.querySelector('.wsc-peek-finger');
        if (oldFinger) oldFinger.remove();
        // Add finger
        var fingerEl = document.createElement('div');
        fingerEl.className = 'wsc-peek-finger';
        fingerEl.innerHTML = '\uD83D\uDC46';
        hdr.appendChild(fingerEl);
      }, 300);
    }, peekDur);
  }

  // Compare-at prices are SSR'd into wsc-product-meta at page load. Items added
  // via JS after load have no meta -> no strikethrough/savings. Fetch each
  // missing handle's product JSON once and patch productMeta, then re-render.
  var _wscMetaFetched = {};
  function fetchMissingMeta() {
    if (!cart) return;
    var need = [];
    cart.items.forEach(function(it) {
      var m = productMeta[it.variant_id];
      if ((!m || !m.compare_at_price) && it.handle && !_wscMetaFetched[it.handle]) {
        _wscMetaFetched[it.handle] = 1;
        need.push(it.handle);
      }
    });
    if (!need.length) return;
    var pending = need.length, changed = false;
    function done() {
      pending--;
      if (pending === 0 && changed) refreshUI();
    }
    need.forEach(function(h) {
      fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) {
          if (p && Array.isArray(p.variants)) {
            p.variants.forEach(function(v) {
              var entry = productMeta[v.id] || (productMeta[v.id] = {});
              if (v.compare_at_price && !entry.compare_at_price) {
                entry.compare_at_price = v.compare_at_price;
                changed = true;
              }
            });
          }
          done();
        })
        .catch(function() { done(); });
    });
  }

  function refreshUI() {
    fetchMissingMeta();
    renderItems();
    populateCartItems();
    updateProgress();
    updateFreebies();
    renderInlineTeaser();
    renderWellnessTimeline(activeGoalId);
    renderAlsoBought();
    renderVolumeTier();
    renderBundleNudge();
    updateFooter();
  }

  /* ═══════════════════════════════════════
     SCROLL HINT
     ═══════════════════════════════════════ */



  /* ═══════════════════════════════════════
     OPEN / CLOSE
     ═══════════════════════════════════════ */

  function wscUnlockBody() {
    if (!window._wscLockOwner) return; // someone else (menu drawer) owns the lock
    window._wscLockOwner = false;
    if (document.body.style.position === 'fixed') {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, window._wscScrollY || 0);
    }
  }

  function openDrawer(skipFetch) {
    var d = $('wsc-drawer'), o = $('wsc-overlay');
    if (d) d.classList.add('wsc-open');
    if (o) o.classList.add('wsc-open');
    // iOS-safe scroll lock — only on first open; re-entrant calls (in-drawer ADD
    // buttons) must NOT overwrite the saved scroll position with 0
    if (document.body.style.position !== 'fixed') {
      window._wscLockOwner = true;
      window._wscScrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + window._wscScrollY + 'px';
      document.body.style.width = '100%';
    }

    // Always refresh UI with current cart data
    if (!skipFetch && (Date.now() - lastFetchAt > 2000)) {
      fetchCart(function() { refreshUI(); });
    } else if (cart) {
      // Cart data exists from init, just render
      refreshUI();
    }

    // Auto-peek wellness accordion on first open
    if (!peekDone && settings.enable_wellness && wellnessGoals.length > 0 && cart && cart.items.length > 0) {
      peekDone = true;
      // Delay to ensure content is rendered (init fetchCart may still be in flight)
      setTimeout(wellnessAutoPeek, settings.wellness_peek_delay || 1500);
    }
  }

  function closeDrawer() {
    userOpenedWellness = false;
    if (peekCloseTimer) { clearTimeout(peekCloseTimer); peekCloseTimer = null; }
    // Note: peekDone is NOT reset here — peek only happens once per page load
    var d = $('wsc-drawer'), o = $('wsc-overlay');
    if (d) d.classList.remove('wsc-open');
    if (o) o.classList.remove('wsc-open');
    // Restore scroll
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, window._wscScrollY || 0);
  }

  function goToCheckout() {
    if (!cart || cart.item_count === 0) return;

    // Show loading state on button
    var btn = $('wsc-checkout-btn');
    if (btn) {
      btn.textContent = 'Processing...';
      btn.disabled = true;
      btn.style.opacity = '.7';
    }

    function launchHeadless() {
      wscUnlockBody();
      window.HeadlessCheckout.checkout();
      // Reset button after a delay in case user comes back
      setTimeout(function() {
        if (btn) { btn.textContent = settings.checkout_btn_text || 'Buy Now \u2192'; btn.disabled = false; btn.style.opacity = ''; }
      }, 3000);
    }

    // Trigger Shiprocket headless checkout if available
    if (window.HeadlessCheckout && typeof window.HeadlessCheckout.checkout === 'function') {
      launchHeadless();
      return;
    }

    // Headless script may still be loading (slow 3G) - poll up to 3s before giving up
    var waited = 0;
    var poll = setInterval(function() {
      waited += 300;
      if (window.HeadlessCheckout && typeof window.HeadlessCheckout.checkout === 'function') {
        clearInterval(poll);
        launchHeadless();
        return;
      }
      if (waited >= 3000) {
        clearInterval(poll);
        // Fallback to Shopify checkout
        wscUnlockBody();
        var url = '/checkout';
        // discount code handled by Shiprocket
        window.location.href = url;
      }
    }, 300);
  }

  /* ═══════════════════════════════════════
     MINIMOG INTERCEPT
     ═══════════════════════════════════════ */

  function interceptMinimog() {
    var md = document.getElementById('MinimogCartDrawer');

    document.addEventListener('click', function(e) {
      var el = e.target.closest(
        '[data-cart-toggle], [href="/cart"], .m-cart-drawer-toggle, '
        + '[data-action="toggle-cart"], .m-cart-icon, '
        + '[data-open-cart-drawer], .m-header__action-item--cart'
      );
      if (!el) {
        var link = e.target.closest('a[href]');
        if (link && link.getAttribute('href') === '/cart') el = link;
      }
      if (el) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      }
    }, true);

    var overlay = $('wsc-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    if (md) {
      new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.attributeName === 'class' || m.attributeName === 'open') {
            if (md.hasAttribute('open') || md.classList.contains('m-cart-drawer--active')) {
              md.removeAttribute('open');
              md.classList.remove('m-cart-drawer--active');
              md.style.display = 'none';
              openDrawer();
            }
          }
        });
      }).observe(md, { attributes: true });
    }

    if (window.MinimogEvents && window.MinimogEvents.subscribe) {
      window.MinimogEvents.subscribe('cart-drawer:open', function() {
        if (md) { md.classList.remove('m-cart-drawer--active'); md.style.display = 'none'; }
        openDrawer();
      });
      window.MinimogEvents.subscribe('cart:added', function() {
        // Don't open here — the fetch monkey-patch handles it
        // This prevents double-open
      });
    }

    document.addEventListener('cart:refresh', function(e) {
      e.stopImmediatePropagation();
      if (e.detail && e.detail.cart) {
        cart = e.detail.cart;
        lastFetchAt = Date.now();
        refreshUI();
      } else {
        fetchCart(function() { refreshUI(); });
      }
      if (e.detail && e.detail.open) openDrawer();
    }, true);

    // Fetch monkey-patch — intercept ALL /cart/add fetches
    var _wscOrigFetch = window.fetch;

    // Form submit intercept — block page navigation, extract form data, POST via fetch
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.action && form.action.indexOf('/cart/add') !== -1) {
        e.preventDefault();
        // Minimog's <product-form> has its own submit listener on the form itself, and it
        // never checks defaultPrevented — so without this it ALSO posts to /cart/add and the
        // customer gets two of the item. Listing pages doubled 83-92% of adds; product pages
        // were unaffected because they use the custom weshuddh buy-buttons (fetch, no form).
        // Only this /cart/add branch stops the event: the cart-page form and Shopify's
        // captcha listener post elsewhere and are untouched.
        e.stopImmediatePropagation();
        var formData = new FormData(form);
        _wscAddingN++;
        _wscOrigFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: formData
        })
        .then(function(r) {
          if (!r.ok) throw new Error('/cart/add.js form submit responded ' + r.status);
          return r.json();
        })
        .then(function() {
          _wscAddingN = Math.max(0,_wscAddingN-1);
          lastFetchAt = 0; // cart just mutated — bust the fetch throttle so we never render a stale cart
          fetchCart(function() { refreshUI(); openDrawer(true); });
        })
        .catch(function(err) {
          _wscAddingN = Math.max(0,_wscAddingN-1);
          console.error('WSC: form add failed', err);
        });
      }
    }, true);
    window.fetch = function() {
      var url = arguments[0];
      var opts = arguments[1] || {};
      var urlStr = '';
      if (typeof url === 'string') urlStr = url;
      else if (url instanceof Request) urlStr = url.url;
      var method = (opts.method || (url instanceof Request && url.method) || 'GET').toUpperCase();
      if (urlStr.indexOf('/cart/add') !== -1 && method === 'POST') {
        if (_wscAddingN > 0) {
          // Our own addToCart/claimSlot — pass through, they handle their own refresh
          return _wscOrigFetch.apply(this, arguments);
        }
        // External add (theme JS, etc.) — let it through, then refresh our cart
        return _wscOrigFetch.apply(this, arguments).then(function(resp) {
          setTimeout(function() { lastFetchAt = 0; fetchCart(function() { refreshUI(); openDrawer(true); }); }, 150);
          return resp;
        });
      }
      return _wscOrigFetch.apply(this, arguments);
    };
  }

  /* ═══════════════════════════════════════
     ESCAPE KEY
     ═══════════════════════════════════════ */

  function initKeyboard() {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var d = $('wsc-drawer');
        if (d && d.classList.contains('wsc-open')) {
          closeDrawer();
        }
      }
    });
  }

  /* ═══════════════════════════════════════
     INIT
     ═══════════════════════════════════════ */

  function init() {
    loadSettings();

    var closeBtn = $('wsc-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // scroll hint listener removed

    initEventDelegation();
    initKeyboard();
    interceptMinimog();

    fetchCart(function(c) {
      var total = c.total_price;
      for (var i = milestones.length - 1; i >= 0; i--) {
        if (total >= milestones[i].val) { prevMilestone = i; break; }
      }
      initialized = true;
      // Don't re-render items on first load — Liquid HTML is already correct
      updateProgress();
      updateFreebies();
      renderVolumeTier();
      renderBundleNudge();
      updateFooter();
      // Populate tags + stars from hardcoded data
      populateCartItems();
    });

    initTimers();
  }

  window.WSC = {
    open: openDrawer,
    close: closeDrawer,
    refresh: function() { fetchCart(function() { refreshUI(); }); },
    addToCart: addToCart
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
